<template>
  <div>
    <!-- <loading 
     :active.sync="loadingApplication" 
        :is-full-page="true"
        color="green"
    ></loading>-->
    <v-toolbar flat color="white">
      <v-layout align-center justify-center>
        <v-flex xs3>
          <v-chip color="green" class="white--text" v-if="applicationInfo.isResolved && applicationInfo.isApproved"
            >Approved</v-chip
          >
          <v-chip color="red" class="white--text" v-else-if="applicationInfo.isResolved && applicationInfo.isDenied"
            >Denied</v-chip
          >
          <v-chip color="light-blue" class="white--text" v-else>Pending</v-chip>
        </v-flex>
        <v-flex xs9>
          <h3 class="dark-grey--text px-2">
            <v-layout>
              <span class="grey--text font-weight-light"> Order ID: {{ applicationInfo.id }}</span>
            </v-layout>
            <!-- <v-layout>
              <span class="grey--text font-weight-light" v-if="applicationInfo.locationId">
                {{ applicationInfo.location.locationDescription }}
              </span>

              <span class="grey--text font-weight-light" v-else-if="applicationInfo.locationNetwork">
                {{ applicationInfo.streetNumber }} {{ applicationInfo.streetName }}
              </span>
              <v-icon align-center justify-center style="margin-left:10px" @click="goToLocation()"
                >remove_red_eye</v-icon
              >
            </v-layout>
            <v-layout>
              <span class="grey--text font-weight-light" v-if="applicationInfo.locationId">{{
                applicationInfo.location.locationNetwork.name
              }}</span>
              <span class="grey--text font-weight-light" v-else-if="applicationInfo.locationNetwork">{{
                applicationInfo.locationNetwork.name
              }}</span>
            </v-layout> -->
          </h3>
        </v-flex>
      </v-layout>
      <v-spacer></v-spacer>
      <div v-if="applicationInfo.isDeviceVerified">
        <v-btn
          round
          color="primary"
          class="white--text"
          v-if="
            !applicationInfo.isResolved &&
              !applicationInfo.ispVerified &&
              applicationInfo.packagesIsp.datatillProductId &&
              datatillIntegration
          "
          @click="
            clearIntegrationFields();
            addCustomerModal = true;
          "
          >Approve</v-btn
        >
        <v-btn
          round
          color="primary"
          class="white--text"
          v-else-if="!applicationInfo.isResolved && !applicationInfo.ispVerified"
          @click="
            clearIntegrationFields();
            ispVerifyModal();
          "
          >Approve</v-btn
        >

        <h4 class="grey--text " v-else-if="applicationInfo.ispAccepted && applicationInfo.ispVerifiedById != null">
          Approved By: {{ applicationInfo.ispVerifiedBy.name }} {{ applicationInfo.ispVerifiedBy.surname }} <br />
          <span>{{ formatDate(applicationInfo.ispVerifiedDate) }}</span>
        </h4>
        <h4 class="grey--text " v-else-if="!applicationInfo.ispAccepted && applicationInfo.ispVerifiedById != null">
          Rejected By: {{ applicationInfo.ispVerifiedBy.name }} {{ applicationInfo.ispVerifiedBy.surname }} <br />
          <span>{{ formatDate(applicationInfo.ispVerifiedDate) }}</span>
        </h4>
        <v-btn
          round
          color="red"
          class="white--text"
          v-if="!applicationInfo.isResolved && !applicationInfo.ispVerified"
          @click="deniedReasonModal = true"
          >Reject</v-btn
        >
      </div>
      <span v-else class="grey--text "
        >Installation verification is required by the FNO before you are able to approve this application.</span
      >
    </v-toolbar>
    <v-divider></v-divider>
    <v-stepper class="elevation-0" alt-labels>
      <v-stepper-header>
        <v-stepper-step step="1" complete color="light-green">
          Order Received
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step color="light-green" step="2" :complete="applicationInfo.isContactVerified">
          Contact(s) Verified
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          color="light-green"
          :complete="applicationInfo.isInstallVerified && applicationInfo.isDeviceVerified"
          step="3"
        >
          Installation Verified
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4" color="light-green" :complete="applicationInfo.ispAccepted">
          ISP Approved
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          step="5"
          color="light-green"
          :complete="applicationInfo.isResolved && applicationInfo.isApproved"
          :rules="[
            () => {
              if (applicationInfo.isResolved && applicationInfo.isDenied) {
                return false;
              } else {
                return true;
              }
            },
          ]"
        >
          FNO Approved
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="6" color="light-green" :complete="applicationInfo.isResolved">
          Complete
        </v-stepper-step>
      </v-stepper-header>
    </v-stepper>
    <v-card flat>
      <v-snackbar :top="y === 'top'" v-model="snackbar">
        {{ text }}
        <v-btn color="primary" flat @click="snackbar = false">X</v-btn>
      </v-snackbar>
      <v-container grid-list-xs>
        <v-layout wrap>
          <v-flex xs12 sm6 md6 mb-1>
            <v-card elevation="5" class="rounded-card">
              <v-card-text>
                <v-list>
                   <v-list-tile>
        <v-list-tile-action>
          <v-icon  v-if="applicationInfo.location">location_on</v-icon>
          <v-icon color="warning" v-else>warning</v-icon>
          </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title v-if="applicationInfo.location">
            {{ applicationInfo.location.locationDescription }}
          </v-list-tile-title>
          <v-list-tile-title v-else>
            {{ formattedAddress }}
          </v-list-tile-title>
          <v-list-tile-subtitle>
              <span class="grey--text font-weight-light" v-if="applicationInfo.locationId">{{
                applicationInfo.location.locationNetwork.name
              }}</span>
              <span class="grey--text font-weight-light" v-else-if="applicationInfo.locationNetwork">{{
                applicationInfo.locationNetwork.name
              }}</span>
          </v-list-tile-subtitle>
        </v-list-tile-content>
      </v-list-tile>    
                </v-list>
                <h2 class="dark-grey--text">Request Summary</h2>
                <!-- <v-btn @click="findSimilarContacts('Mark')">Similar Xero Contacts</v-btn> -->
                <v-container grid-list-xs>
                  <v-layout wrap v-if="applicationInfo">
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout justify-left>
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Date Submitted:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">{{ formatDate(applicationInfo.createdAt) }}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex xs8 v-if="applicationInfo.activationDate">
                          <h2 class="subheading grey--text font-weight-bold">Preferred Activation Date:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">{{ applicationInfo.activationDate }}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="applicationInfo.packagesIspId !== null">
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Router Installation Fee:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">
                            {{ applicationInfo.routerInstallationFee | currency }}
                          </h3>
                        </v-flex>
                      </v-layout>

                      <v-layout justify-center>
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Data Package:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3
                            class="grey--text font-weight-light"
                            v-if="applicationInfo && applicationInfo.packagesIspId !== null"
                          >
                            {{ applicationInfo.packagesIsp.customerOrganisation.name }} |
                            {{ applicationInfo.packagesIsp.name }}
                          </h3>
                          <v-icon color="red" v-else>not_interested</v-icon>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="applicationInfo.packagesIspId !== null">
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Data Package Term:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">{{ applicationInfo.packagesIsp.term }}</h3>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="applicationInfo.packagesIspId !== null">
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Data Package Monthly Payment:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">
                            {{ applicationInfo.ispRecurringPriceVatInc | currency }}
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout v-if="applicationInfo.packagesIspId !== null">
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Data Package Once-Off:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">
                            {{ applicationInfo.ispOnceOffPriceVatInc | currency }}
                          </h3>
                        </v-flex>
                      </v-layout>
                      <v-layout v-if="applicationInfo.isValidPromo !== null">
                        <v-flex xs8>
                          <h3 class="subheading grey--text font-weight-bold">
                            Promotion Code:
                          </h3>
                        </v-flex>
                        <v-flex xs4>
                          <v-layout>
                            <h3
                              v-if="applicationInfo && applicationInfo.promotion"
                              class="grey--text font-weight-light"
                            >
                              {{ applicationInfo.promotion.name }}
                              <v-chip
                                small
                                v-if="applicationInfo.isValidPromo == true"
                                class="white--text "
                                color="light-green"
                                >Valid</v-chip
                              >
                              <v-chip small v-else class="white--text " color="orange">Invalid</v-chip>
                            </h3>
                            <h3
                              v-else-if="applicationInfo && applicationInfo.promoCode"
                              class="grey--text font-weight-light"
                            >
                              {{ applicationInfo.promoCode }}
                              <v-chip
                                small
                                v-if="applicationInfo.isValidPromo == true"
                                class="white--text "
                                color="light-green"
                                >Valid</v-chip
                              >
                              <v-chip small v-else class="white--text " color="orange">Invalid</v-chip>
                            </h3>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout>
                        <v-flex xs8>
                          <h3 class="subheading grey--text font-weight-bold">
                            Notes:
                          </h3>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light" style="word-wrap: break-word">
                            {{ applicationInfo.notes }}
                          </h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
            <!-- <v-card-text v-if="(applicationInfo.routerInstallationFee>0)||(applicationInfo.hasTvOverFibre&&applicationInfo.gtuInstallationFee>0)">
            <h2 class="dark-grey--text">Billing <v-btn v-if="!applicationInfo.isInvoiced" round class="primary" @click="generateXeroInvoice()">Create Xero Invoice</v-btn></h2>
            <v-container grid-list-xs>
              <v-layout wrap>
                <v-flex xs12 sm12 md12  text-xs-left>
            <v-layout justify-center>
                        <v-flex xs8>
                            <h2 class="subheading grey--text font-weight-bold"> Installation Fees Invoiced:</h2>
                        </v-flex>
                        <v-flex xs4>
                        <h3 class="grey--text font-weight-light" v-if="applicationInfo.isInvoiced"><v-icon color="light-green">check</v-icon><span class="grey--text font-weight-light" v-if="applicationInfo.invoiceNumber!==''">
                           | Invoice No: {{applicationInfo.invoiceNumber}}</span></h3>
                        <h3 class="grey--text font-weight-light" v-else><v-icon color="red">not_interested</v-icon></h3>
                        </v-flex>
                    </v-layout>
                    </v-flex>
              </v-layout>
              <v-layout wrap>
              <v-flex xs12 sm12 md12  text-xs-left>
              <v-layout justify-center v-if="applicationInfo.isInvoiced">
                        <v-flex xs8>
                            <h2 class="subheading grey--text font-weight-bold"> Invoice Paid:</h2>
                        </v-flex>
                        <v-flex xs4>
                        <h3 class="grey--text font-weight-light" v-if="applicationInfo.isPaid"><v-icon color="light-green">check</v-icon></h3>
                        <h3 class="grey--text font-weight-light" v-else><v-icon color="red">not_interested</v-icon></h3>
                        </v-flex>
                    </v-layout>
                    </v-flex>
              </v-layout>
            </v-container>
            </v-card-text>-->
          </v-flex>
          <v-flex xs12 sm6 md6 lg6 mb-1>
            <!-- <v-layout>
               <v-flex xs12 >
                <v-card elevation="5" class="rounded-card">
              <v-card-text>
                <h2 class="dark-grey--text font-weight-bold">Access Build 
                  </h2>
              
                 <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout justify-center>
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">
                            Additional Fee (excl. VAT):
                          </h2>
                        </v-flex>
                        <v-flex xs4 >
                           <h3
                          class="grey--text font-weight-light"
                        >{{applicationInfo.additionalAccessBuildFeeExclVat|currency}}</h3>
                        </v-flex>
                  </v-layout>
                 <v-layout justify-center>
                        <v-flex xs8>
                            <h2 class="subheading grey--text font-weight-bold">Document: </h2>
                        </v-flex>
                        <v-flex xs4>
                          <v-layout>                         
                            <v-flex xs6>
                            <v-icon color="green" v-if="applicationInfo.additionalAccessBuildDocument">done</v-icon>
                            <v-icon color="red" v-else>not_interested</v-icon>
                            </v-flex>
                             <v-flex xs6>
                       <a  v-if="applicationInfo.additionalAccessBuildDocument!==null" download="additionalAccessBuildDocument.pdf" :href="applicationInfo.additionalAccessBuildDocument"><v-icon medium color="primary">cloud_download</v-icon></a>
                             </v-flex>
                          </v-layout>
                        </v-flex>                 
                    </v-layout>
                    </v-flex>
                  </v-layout>
                 </v-container>
              </v-card-text>
              </v-card>
              </v-flex>
            </v-layout> -->

            <v-layout>
              <v-flex xs12>
                <v-card elevation="5" class="rounded-card">
                  <v-card-text>
                    <h2 class="dark-grey--text font-weight-bold">
                      <v-icon v-if="!applicationInfo.isResolved && !applicationInfo.isContactVerified" color="orange"
                        >warning</v-icon
                      >Contact Information
                      <v-chip
                        v-if="
                          !verifyingContact &&
                            !applicationInfo.isResolved &&
                            !applicationInfo.isContactVerified &&
                            applicationInfo.primaryContactId !== null
                        "
                        class="white--text"
                        color="warning"
                        >Pending Verification
                      </v-chip>
                      <v-chip v-if="applicationInfo.isContactVerified" class="white--text" color="success">
                        Verified
                      </v-chip>
                    </h2>

                    <v-container v-if="showApplicationContacts">
                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12 lg12 v-if="applicationContactIndex === 0">
                          <v-layout align-center>
                            <v-flex xs2>
                              <v-icon @click="applicationContactIndex--" v-if="applicationContactIndex > 0"
                                >keyboard_arrow_left</v-icon
                              >
                            </v-flex>
                            <v-flex xs8>
                              <v-card hover class="text-xs-center mb-2 mx-2">
                                <div class="primary subheading text-uppercase white--text">Primary</div>
                                <v-responsive></v-responsive>
                                <v-card-text>
                                  <div class="subheading" v-if="applicationInfo.primaryContactTitle !== null">
                                    {{ applicationInfo.primaryContactTitle }}
                                    {{ applicationInfo.primaryContactFirstname }}
                                    {{ applicationInfo.primaryContactLastname }}
                                  </div>
                                  <div class="subheading" v-else>
                                    {{ applicationInfo.primaryContactFirstname }}
                                    {{ applicationInfo.primaryContactLastname }}
                                  </div>
                                  <v-layout>
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">smartphone</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                                        {{ applicationInfo.primaryContactMobileNumber }}
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">email</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                                        {{ applicationInfo.primaryContactEmailAddress }}
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                  <v-layout>
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">perm_identity</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                                        {{ applicationInfo.primaryContactIdNumber }}
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs2>
                              <v-icon
                                @click="applicationContactIndex++"
                                v-if="
                                  applicationInfo.secondaryContactFirstname !== null ||
                                    applicationInfo.billingContactFirstname !== null
                                "
                                >keyboard_arrow_right</v-icon
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                          lg12
                          v-if="applicationContactIndex === 1 && applicationInfo.secondaryContactFirstname !== null"
                        >
                          <v-layout align-center>
                            <v-flex xs2>
                              <v-icon @click="applicationContactIndex--" v-if="applicationContactIndex > 0"
                                >keyboard_arrow_left</v-icon
                              >
                            </v-flex>
                            <v-flex xs8>
                              <v-card hover class="text-xs-center mb-2 mx-2">
                                <div class="primary subheading text-uppercase white--text">Secondary</div>
                                <v-responsive></v-responsive>
                                <v-card-text>
                                  <div class="subheading" v-if="applicationInfo.secondaryContactTitle !== null">
                                    {{ applicationInfo.secondaryContactTitle }}
                                    {{ applicationInfo.secondaryContactFirstname }}
                                    {{ applicationInfo.secondaryContactLastname }}
                                  </div>
                                  <div class="subheading" v-else>
                                    {{ applicationInfo.secondaryContactFirstname }}
                                    {{ applicationInfo.secondaryContactLastname }}
                                  </div>
                                  <v-layout v-if="applicationInfo.secondaryContactMobileNumber !== null">
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">smartphone</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                                        {{ applicationInfo.secondaryContactMobileNumber }}
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout v-if="applicationInfo.secondaryContactEmailAddress !== null">
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">email</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                                        {{ applicationInfo.secondaryContactEmailAddress }}
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout v-if="applicationInfo.secondaryContactIdNumber !== null">
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">perm_identity</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                                        {{ applicationInfo.secondaryContactIdNumber }}
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs2>
                              <v-icon
                                @click="applicationContactIndex++"
                                v-if="applicationInfo.billingContactFirstname !== null"
                                >keyboard_arrow_right</v-icon
                              >
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex
                          xs12
                          sm12
                          md12
                          lg12
                          v-if="
                            (applicationContactIndex === 1 &&
                              applicationInfo.secondaryContactFirstname === null &&
                              applicationInfo.billingContactFirstname !== null) ||
                              (applicationContactIndex === 2 &&
                                applicationInfo.secondaryContactFirstname !== null &&
                                applicationInfo.billingContactFirstname !== null)
                          "
                        >
                          <v-layout align-center>
                            <v-flex xs2>
                              <v-icon @click="applicationContactIndex--" v-if="applicationContactIndex > 0"
                                >keyboard_arrow_left</v-icon
                              >
                            </v-flex>
                            <v-flex xs8>
                              <v-card hover class="text-xs-center mb-2 mx-2">
                                <div class="primary subheading text-uppercase white--text">Billing</div>
                                <v-responsive></v-responsive>
                                <v-card-text>
                                  <div class="subheading" v-if="applicationInfo.billingContactTitle !== null">
                                    {{ applicationInfo.billingContactTitle }}
                                    {{ applicationInfo.billingContactFirstname }}
                                    {{ applicationInfo.billingContactLastname }}
                                  </div>
                                  <div class="subheading" v-else>
                                    {{ applicationInfo.billingContactFirstname }}
                                    {{ applicationInfo.billingContactLastname }}
                                  </div>
                                  <v-layout v-if="applicationInfo.billingContactMobileNumber !== null">
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">smartphone</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                                        {{ applicationInfo.billingContactMobileNumber }}
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout v-if="applicationInfo.billingContactEmailAddress !== null">
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">email</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                                        {{ applicationInfo.billingContactEmailAddress }}
                                      </div>
                                    </v-flex>
                                  </v-layout>

                                  <v-layout v-if="applicationInfo.billingContactIdNumber !== null">
                                    <v-flex xs2 class="text-xs-right">
                                      <v-icon small color="grey">perm_identity</v-icon>
                                    </v-flex>
                                    <v-flex xs8 justify-left>
                                      <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                                        {{ applicationInfo.billingContactIdNumber }}
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </v-card-text>
                              </v-card>
                            </v-flex>
                            <v-flex xs2> </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm6 md6 mb-1>
            <v-card elevation="5" class="rounded-card">
              <v-card-text>
                <h2 class="dark-grey--text font-weight-bold">
                  <v-icon
                    v-if="
                      !applicationInfo.isResolved &&
                        (!applicationInfo.isInstallVerified || !applicationInfo.isDeviceVerified)
                    "
                    color="orange"
                    >warning</v-icon
                  >Installation Information
                  <v-chip
                    v-if="
                      !verifyingInstallation &&
                        !verifyingDevice &&
                        !applicationInfo.isResolved &&
                        applicationInfo.location &&
                        applicationInfo.location.fibrePulled &&
                        applicationInfo.location.equipmentInstalled &&
                        (!applicationInfo.isInstallVerified || !applicationInfo.isDeviceVerified)
                    "
                    class="white--text"
                    color="warning"
                    >Pending Verification
                  </v-chip>
                  <v-chip
                    v-if="applicationInfo.isInstallVerified && applicationInfo.isDeviceVerified"
                    class="white--text"
                    color="success"
                  >
                    Verified
                  </v-chip>
                </h2>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 text-xs-left>
                      <v-layout justify-center>
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">
                            <v-icon v-if="applicationInfo.location && !applicationInfo.location.fibrePulled" color="red"
                              >error_outline</v-icon
                            >Passive Installation Complete:
                          </h2>
                        </v-flex>
                        <v-flex xs4>
                          <v-icon color="green" v-if="applicationInfo.location && applicationInfo.location.fibrePulled"
                            >done</v-icon
                          >
                          <v-icon color="red" v-else>not_interested</v-icon>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center>
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">
                            <v-icon
                              v-if="applicationInfo.location && !applicationInfo.location.equipmentInstalled"
                              color="red"
                              >error_outline</v-icon
                            >Device Installation Complete:
                          </h2>
                        </v-flex>
                        <v-flex xs4>
                          <v-icon
                            color="green"
                            v-if="applicationInfo.location && applicationInfo.location.equipmentInstalled"
                            >done</v-icon
                          >
                          <v-icon color="red" v-else>not_interested</v-icon>
                        </v-flex>
                      </v-layout>
                      <v-layout justify-center v-if="this.device !== null">
                        <v-flex xs8>
                          <h2 class="subheading grey--text font-weight-bold">Device Installed:</h2>
                        </v-flex>
                        <v-flex xs4>
                          <h3 class="grey--text font-weight-light">
                            {{ device.deviceMakeModel.deviceMake.name }} {{ device.deviceMakeModel.name }} |
                            {{ device.ponMac }}
                          </h3>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex
            xs12
            sm6
            md6
            mb-1
            v-if="applicationInfo.serviceAccountId == null && applicationInfo.serviceAccountType != null"
          >
            <v-card elevation="5" class="rounded-card">
              <v-card-text>
                <h2 class="dark-grey--text font-weight-bold">Service Account Information</h2>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12>
                      <v-card flat class="text-xs-center mb-2 mx-2">
                        <v-responsive></v-responsive>
                        <v-flex xs12 text-xs-center mb-2>
                          <v-layout wrap>
                            <v-flex xs12 sm12 md12 text-xs-left>
                              <v-layout justify-left>
                                <v-flex xs8>
                                  <h2 class="subheading grey--text font-weight-bold">Service Account Type:</h2>
                                </v-flex>
                                <v-flex xs4>
                                  <h3 class="grey--text font-weight-light">{{ applicationInfo.serviceAccountType }}</h3>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-left v-if="applicationInfo.serviceAccountType == 'PPPoE'">
                                <v-flex xs8>
                                  <h2 class="subheading grey--text font-weight-bold">PPPoE Username:</h2>
                                </v-flex>
                                <v-flex xs4>
                                  <h3 class="grey--text font-weight-light">{{ applicationInfo.pppoeUsername }}</h3>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-left v-if="applicationInfo.serviceAccountType == 'PPPoE'">
                                <v-flex xs8>
                                  <h2 class="subheading grey--text font-weight-bold">PPPoE Password:</h2>
                                </v-flex>
                                <v-flex xs4>
                                  <h3 class="grey--text font-weight-light">{{ applicationInfo.pppoePassword }}</h3>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 md6 mb-1 v-if="applicationInfo.serviceAccountId !== null && applicationInfo.serviceAccount">
            <v-card elevation="5" class="rounded-card">
              <v-card-text>
                <h2 class="dark-grey--text font-weight-bold">Associated Service Account</h2>
                <v-container grid-list-xs>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md6 lg>
                      <v-card hover class="text-xs-center mb-2 mx-2">
                        <div class="primary subheading text-uppercase white--text">
                          {{ applicationInfo.serviceAccount.packagesIsp.customerOrganisation.name }}
                        </div>
                        <v-responsive></v-responsive>
                        <v-card-text>
                          <div class="grey--text">
                            <b>{{ applicationInfo.serviceAccount.packagesIsp.name }}</b>
                          </div>
                          <div class="grey--text">
                            <!-- <b>Cir:</b> -->
                            {{ applicationInfo.serviceAccount.circuitNumber }}
                          </div>
                          <div class="grey--text" v-if="applicationInfo.serviceAccount.initialActivation !== null">
                            <b>Active From:</b>
                            {{ formatDate(applicationInfo.serviceAccount.initialActivation) }}
                          </div>
                          <div class="grey--text" v-else><b>Active From:</b> No Activation Date</div>
                          <div class="grey--text" v-if="applicationInfo.serviceAccount.fnoDeactivationDate !== null">
                            <b>Active To:</b>
                            {{ formatDate(applicationInfo.serviceAccount.fnoDeactivationDate) }}
                          </div>
                          <div
                            class="grey--text"
                            v-else-if="applicationInfo.serviceAccount.ispDeactivationDate !== null"
                          >
                            <b>Active To:</b>
                            {{ formatDate(applicationInfo.serviceAccount.ispDeactivationDate) }}
                          </div>
                          <div class="grey--text" v-else><b>Active To:</b> No Deactivation Date</div>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-flex>

          <v-flex xs12 sm6 md6 mb-1 v-if="tickets.length > 0" :key="ticketKey">
            <v-card elevation="5" class="rounded-card">
              <h2 class="dark-grey--text font-weight-bold">
                Tickets
                <v-icon color="primary" @click="fetchTickets()">refresh</v-icon>
              </h2>
              <v-container>
                <v-layout align-center :key="ticketKey">
                  <v-flex xs1>
                    <v-icon @click="backTicketArrow()" v-if="ticketIndex > 0">keyboard_arrow_left</v-icon>
                  </v-flex>

                  <v-layout v-for="ticket in ticketCarousalArray" :key="ticket.id">
                    <v-flex xs12 mx-1>
                      <v-card min-height="300px" hover border-color="red" @click="routeToTicketSummary(ticket.id)">
                        <v-toolbar flat color="primary">
                          <h3 class="title white--text">
                            {{ ticket.ticketCategoryItem.ticketCategory.name }}:
                            {{ ticket.ticketCategoryItem.name }}
                          </h3>
                        </v-toolbar>
                        <v-container grid-list-xs>
                          <v-layout wrap>
                            <v-flex xs12 sm12 md12 text-xs-left>
                              <v-layout justify-center align-center>
                                <v-flex xs6>
                                  <h2 class="subheading grey--text font-weight-bold">
                                    Status:
                                  </h2>
                                </v-flex>
                                <v-flex xs6>
                                  <h3 class="grey--text">
                                    <v-chip
                                      small
                                      :class="`${ticket.currentStatus.replace(/\s/g, '').toLowerCase()} white--text`"
                                      >{{ ticket.currentStatus }}</v-chip
                                    >
                                  </h3>
                                </v-flex>
                              </v-layout>

                              <v-layout justify-left>
                                <v-flex xs6>
                                  <h2 class="subheading grey--text font-weight-bold">
                                    Ticket ID:
                                  </h2>
                                </v-flex>
                                <v-flex xs6>
                                  <h3 class="grey--text font-weight-light">
                                    {{ ticket.id }}
                                  </h3>
                                </v-flex>
                              </v-layout>

                              <v-layout v-if="ticket.description" justify-center>
                                <v-flex xs6>
                                  <h2 class="subheading grey--text font-weight-bold">
                                    Description:
                                  </h2>
                                </v-flex>
                                <v-flex xs6>
                                  <h3
                                    class="grey--text font-weight-light"
                                    style="max-width:150px; white-space:no-wrap;
                                      text-overflow: ellipsis;
                                      overflow: hidden;
                                    "
                                  >
                                    {{ ticket.description }}
                                  </h3>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-center>
                                <v-flex xs6>
                                  <h2 class="subheading grey--text font-weight-bold">
                                    Due:
                                  </h2>
                                </v-flex>
                                <v-flex xs6>
                                  <h3 class="grey--text font-weight-light" v-if="ticket.dueTime === null">
                                    {{ formatDate(ticket.dueDate) }}
                                  </h3>
                                  <h3 class="grey--text font-weight-light" v-else>
                                    {{ formatDate(ticket.dueDate) }}
                                    {{ ticket.dueTime }}
                                  </h3>
                                </v-flex>
                              </v-layout>

                              <v-layout justify-center>
                                <v-flex xs6>
                                  <h2 class="subheading grey--text font-weight-bold">
                                    Created By:
                                  </h2>
                                </v-flex>
                                <v-flex xs6>
                                  <h3 v-if="ticket.isSystemGenerated" class="grey--text font-weight-light">
                                    System
                                  </h3>
                                  <h3 v-else class="grey--text font-weight-light">
                                    {{ ticket.createdBy.name }}
                                    {{ ticket.createdBy.surname }}
                                  </h3>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-center>
                                <v-flex xs6>
                                  <h2 class="subheading grey--text font-weight-bold">
                                    Assigned To:
                                  </h2>
                                </v-flex>
                                <v-flex xs6>
                                  <h3 v-if="ticket.isSystemGenerated" class="grey--text font-weight-light">
                                    System
                                  </h3>
                                  <h3 v-else-if="ticket.assignedTo !== null" class="grey--text font-weight-light">
                                    {{ ticket.assignedTo.name }}
                                    {{ ticket.assignedTo.surname }}
                                  </h3>
                                  <h3 v-else class="grey--text font-weight-light">
                                    Unassigned
                                  </h3>
                                </v-flex>
                              </v-layout>
                              <v-layout justify-center v-if="ticket.resolvedBy !== null">
                                <v-flex xs6>
                                  <h2 class="subheading grey--text font-weight-bold">
                                    Resolved By:
                                  </h2>
                                </v-flex>
                                <v-flex xs6>
                                  <h3 class="grey--text font-weight-light">
                                    {{ ticket.resolvedBy.name }}
                                    {{ ticket.resolvedBy.surname }}
                                  </h3>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card>
                    </v-flex>
                  </v-layout>
                  <v-flex xs1>
                    <v-icon v-if="ticketIndex < tickets.length - 1" @click="forwardTicketArrow()"
                      >keyboard_arrow_right</v-icon
                    >
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
          <v-flex grow mb-1>
            <v-card elevation="5" class="rounded-card" min-width="300px">
              <v-card-text>
                <h2 class="dark-grey--text font-weight-bold">
                  Comments
                </h2>
                <v-textarea class="mt-1" outline auto-grow v-model="comment"></v-textarea>
                <v-btn @click="addApplicationComment(comment)" round color="primary">Comment</v-btn>
                <v-card flat style="overflow-y: auto; max-height: 1000px">
                  <v-container style="text-align: left">
                    <v-layout wrap>
                      <v-flex xs12 sm12 md12 v-for="item in commentArray" :key="item.id">
                        <h3 class="grey--text font-weight-light">
                          {{ formatDateTime(item.createdAt) }}
                        </h3>
                        <v-layout>
                          <span>
                            <v-tooltip top>
                              <template v-slot:activator="{ on }">
                                <v-avatar
                                  v-on="on"
                                  size="30px"
                                  color="primary"
                                  style="width: 30px"
                                  class="mx-1 font-weight-light white--text"
                                  v-if="item !== 'undefined'"
                                  >{{ item.commentedByName.charAt(0) }}{{ item.commentedBySurname.charAt(0) }}</v-avatar
                                >
                              </template>
                              <span class="font-weight-light"
                                >{{ item.commentedByName }} {{ item.commentedBySurname }}</span
                              >
                            </v-tooltip></span
                          >
                          <span style="text-align: left" class="mt-1 grey--text font-weight-light">{{
                            item.comment
                          }}</span>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>

    <v-dialog v-model="deniedReasonModal" max-width="750px">
      <v-card flat color="white">
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">Please provide a reason for denying the application</h3>
        </v-toolbar>
        <v-card-text>
          <v-textarea label="Reason for Rejection" v-model="deniedReason"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" class="white--text" @click="deniedReasonModal = false">Cancel</v-btn>
            <v-btn v-if="deniedReason" round color="primary" class="white--text" @click="rejectApplication"
              >Reject Application</v-btn
            >
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Invoice Number Modal -->
    <v-dialog v-model="invoiceNumberDialog" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">INVOICE NUMBER</h3>
        </v-toolbar>
        <v-card-text>
          <v-text-field v-model="applicationInfo.invoiceNumber" label="Invoice Number"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="(invoiceNumberDialog = false), (applicationInfo.invoiceNumber = '')"
              >Cancel</v-btn
            >
            <v-btn round color="primary" @click="saveInvoiceStatus">Save</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Invoice Number Modal -->
    <v-dialog v-model="xeroContactsModal" max-width="750px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="headline white--text">SIMILAR CONTACTS IN XERO</h3>
        </v-toolbar>
        <v-flex class="mx-3 my-2" xs6 v-for="contact in similarXeroContacts" :key="contact.ContactId">
          <v-card mx-3 my-2 color="white">
            <v-layout row wrap align-center>
              <v-flex xs6>
                <h3 class="subheading grey--text">{{ contact.name }}</h3>
              </v-flex>
              <v-flex xs6>
                <h4 class="subheading grey--text">Name Match: {{ contact.match }}%</h4>
              </v-flex>
              <v-flex xs6>
                <h4 class="subheading font-weight-light grey--text">{{ contact.email }}</h4>
              </v-flex>
              <v-flex xs6>
                <v-btn round class="primary"> <v-icon color="white">add</v-icon>Invoice </v-btn>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn round color="primary" @click="xeroContactsModal = false">Cancel</v-btn>
            <v-btn round color="primary" @click="createXeroContact()">Create New Xero Contact</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Ticket View Modal -->
    <v-dialog v-model="viewTicketModal" persistent max-width="1000px">
      <v-card>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">VIEW TICKET: {{ ticketItem.dueDate }}</h3>
          <v-spacer></v-spacer>

          <!-- <v-btn v-if="ticketItem.ticketCategoryId&&ticketItem.ticketCategoryItemId&&ticketItem.currentStatus&&ticketItem.importance" flat color="white" class="white--text" @click="editTicketSave()">Save</v-btn>
          <v-btn v-else disabled flat>Save</v-btn>-->
          <v-btn flat color="white" class="white--text" @click="(viewTicketModal = false), (ticketItem = {})">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout justify-center align-center>
            <v-flex xs2>
              <v-checkbox
                v-if="!ticketItem.isSystemGenerated"
                label="Full Day Event"
                v-model="dateTimeSelect"
              ></v-checkbox>
              <v-checkbox v-else disabled label="Full Day Event" v-model="dateTimeSelect"></v-checkbox>
            </v-flex>
            <v-flex xs5>
              <VueCtkDateTimePicker
                v-if="!ticketItem.isSystemGenerated"
                :minDate="today"
                label="Select a Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketItem.dueDate"
              />
              <VueCtkDateTimePicker
                v-else
                disabled
                :minDate="today"
                label="Select a Date"
                autoClose
                format="YYYY-MM-DD"
                formatted="ll"
                only-date
                v-model="ticketItem.dueDate"
              />
            </v-flex>
            <v-flex xs5>
              <VueCtkDateTimePicker
                v-if="!ticketItem.isSystemGenerated && !dateTimeSelect"
                format="HH:mm"
                disabled
                formatted="HH:mm"
                minuteInterval="5"
                label="Select Time"
                only-time
                v-model="ticketItem.dueTime"
              />
              <VueCtkDateTimePicker
                v-else
                disabled
                format="HH:mm"
                formatted="HH:mm"
                minuteInterval="5"
                label="Select Time"
                only-time
                v-model="ticketItem.dueTime"
              />
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-flex xs3>
              <v-autocomplete
                disabled
                v-if="!ticketItem.isSystemGenerated"
                xs6
                :items="ticketCategories"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryId"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                disabled
                xs6
                :items="ticketCategories"
                label="Select a Ticket Category"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete
                disabled
                v-if="!ticketItem.isSystemGenerated && ticketItem.ticketCategoryId"
                xs6
                :items="
                  ticketCategoryItems.filter(
                    (x) => x.ticketCategoryId === ticketItem.ticketCategoryId && x.isActive && !x.isDeleted
                  )
                "
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryItemId"
              ></v-autocomplete>
              <v-autocomplete
                v-else-if="ticketItem.isSystemGenerated"
                disabled
                xs6
                :items="
                  ticketCategoryItems.filter(
                    (x) => x.ticketCategoryId === ticketItem.ticketCategoryId && x.isActive && !x.isDeleted
                  )
                "
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
                v-model="ticketItem.ticketCategoryItemId"
              ></v-autocomplete>
              <v-autocomplete
                v-else
                xs6
                disabled
                :items="ticketCategories"
                label="Select a Subcategory"
                item-text="name"
                item-value="id"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-select
                disabled
                v-if="!ticketItem.isSystemGenerated"
                :items="statuses"
                label="Status"
                v-model="ticketItem.currentStatus"
              ></v-select>
              <v-select v-else disabled :items="statuses" label="Status" v-model="ticketItem.currentStatus"></v-select>
            </v-flex>
            <v-flex xs3>
              <v-select
                disabled
                :items="importanceOptions"
                label="Importance"
                v-model="ticketItem.importance"
              ></v-select>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex xs3>
              <v-select
                disabled
                v-if="!ticketItem.isSystemGenerated"
                :items="locationTypeList"
                label="Type of Associated Location"
                v-model="locationType"
              ></v-select>
              <v-select
                v-else
                disabled
                :items="locationTypeList"
                label="Type of Associated Location"
                v-model="locationType"
              ></v-select>
            </v-flex>
            <v-flex xs3 v-if="locationType === 'Switching Centre'">
              <v-autocomplete
                disabled
                :items="switchingcentres"
                label="Select a Switching Centre"
                item-value="id"
                item-text="name"
                v-model="ticketItem.switchingCentreId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 v-if="locationType === 'Location Node'">
              <v-autocomplete
                disabled
                :items="locationnodes"
                label="Select a Node"
                item-value="id"
                item-text="name"
                v-model="ticketItem.locationNodeId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs3 v-if="locationType === 'Location Network'">
              <v-autocomplete
                disabled
                :items="locationnetworks"
                label="Select a Network"
                item-value="id"
                item-text="name"
                v-model="ticketItem.locationNetworkId"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs2 v-if="locationType === 'End Location'">
              <v-btn
                disabled
                v-if="!ticketItem.isSystemGenerated && !ticketItem.locationId"
                round
                color="primary"
                class="white--text"
                @click="addLocationModal = true"
                >Add Location</v-btn
              >
              <v-btn
                disabled
                v-else-if="!ticketItem.isSystemGenerated"
                round
                color="primary"
                class="white--text"
                @click="addLocationModal = true"
                >Edit Location</v-btn
              >
            </v-flex>
          </v-layout>
          <v-layout justify-center align-center>
            <v-textarea
              disabled
              label="Description"
              v-if="!ticketItem.isSystemGenerated"
              outline
              auto-grow
              v-model="ticketItem.description"
            ></v-textarea>
            <v-textarea
              label="Description"
              v-else
              disabled
              outline
              auto-grow
              v-model="ticketItem.description"
            ></v-textarea>
          </v-layout>
          <v-layout justify-center align-center v-if="ticketAssignedLog.length > 0" mb-2>
            <v-flex xs2>
              <h3 class="grey--text">Assignment Log:</h3>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-for="assigned in ticketAssignedLog" :key="assigned.id">
            <v-layout justify-left align-center class="text-xs-left">
              <v-flex xs3>
                <span class="grey--text">{{ formatDateTime(assigned.createdAt) }}</span>
              </v-flex>
              <v-flex xs9>
                <span class="grey--text font-weight-light">
                  <b>{{ assigned.assignedBy.name }} {{ assigned.assignedBy.surname }}</b>
                  assigned the ticket to
                  <b>{{ assigned.assignedTo.name }} {{ assigned.assignedTo.surname }}</b>
                </span>
              </v-flex>
            </v-layout>
          </v-flex>

          <v-layout justify-center align-center mt-4 mb-2>
            <v-flex xs2>
              <h3 class="grey--text">Comments:</h3>
            </v-flex>
            <v-flex xs1>
              <v-icon color="primary" @click="addCommentBox = true">add_circle_outline</v-icon>
            </v-flex>
          </v-layout>
          <v-flex xs12 v-if="ticketCommentLog.length === 0 && !addCommentBox">
            <h3 class="grey--text font-weight-light">No Comments</h3>
          </v-flex>
          <v-flex xs12 v-if="addCommentBox">
            <v-textarea label="Comment" outline auto-grow v-model="comment"></v-textarea>
            <v-btn round color="primary" class="white--text" @click="addCommentEditedTicket(comment)">Comment</v-btn>
          </v-flex>
          <v-flex xs12 v-for="comment in ticketCommentLog" :key="comment.createdAt">
            <v-layout justify-left align-center class="text-xs-left">
              <v-flex xs2>
                <span class="grey--text font-weight-light">{{ formatDateTime(comment.createdAt) }}</span>
              </v-flex>
              <v-flex xs2>
                <span class="grey--text font-weight-bold"
                  >{{ comment.commentedBy.name }} {{ comment.commentedBy.surname }}</span
                >
              </v-flex>

              <v-flex xs8>
                <span class="grey--text font-weight-light">{{ comment.comment }}</span>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Service Account details Modal -->
    <v-dialog v-model="serviceAccountDetailsModal" persistent max-width="750px" min-width="300px">
      <v-card flat>
        <v-toolbar flat color="primary">
          <h3 class="title white--text">Service Account Details</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="serviceAccountDetailsModal = false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <v-layout ma-1 justify-center>
            <v-flex xs4>
              <v-select
                :items="connectionTypes"
                v-model="applicationInfo.serviceAccountType"
                label="Type of connection"
              ></v-select>
            </v-flex>
            <v-flex xs8 v-if="applicationInfo.serviceAccountType == 'PPPoE'">
              <v-layout>
                <v-text-field label="PPPoE Username" v-model="applicationInfo.pppoeUsername"></v-text-field>
                <v-text-field label="PPPoE Password" v-model="applicationInfo.pppoePassword"></v-text-field>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center>
            <v-btn
              round
              class="white--text"
              color="primary"
              v-if="applicationInfo.serviceAccountType == 'IPoE'"
              @click="submitApproval()"
              >Submit</v-btn
            >
            <v-btn
              round
              class="white--text"
              color="primary"
              v-else-if="
                applicationInfo.serviceAccountType == 'PPPoE' &&
                  applicationInfo.pppoeUsername &&
                  applicationInfo.pppoePassword
              "
              @click="submitApproval()"
              >Submit</v-btn
            >
            <v-btn round disabled v-else>Submit</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addCustomerModal" persistent width="800px">
      <v-card color="white" flat>
        <v-toolbar color="primary" flat>
          <h3 class="title white--text">ADD DATATILL CUSTOMER</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="addCustomerModal = false">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <div v-if="existingDatatillCustomer">
            <v-layout justify-center align-center wrap>
              <h3 style="color:grey">Please select a customer from the existing DataTill customers found</h3>
              <v-flex xs4 mx-1 mt-2 v-for="found in foundExisting" :key="found.customerId">
                <div
                  name="packageCard"
                  :id="found.customerId"
                  class="elevation-5 ma-2 pa-2"
                  style="text-align:center; padding:0px; cursor:pointer;"
                  :class="{ greenBorder: found.customerId == keepColorId }"
                  @click="selectExistingCustomer(found)"
                  hover
                >
                  <div class="primary subheading text-uppercase white--text">{{ found.type }}</div>
                  <v-responsive></v-responsive>
                  <v-card-text>
                    <div class="subheading">{{ found.fullName }}</div>
                    <v-layout v-if="found.mobile !== null">
                      <v-flex xs2 class="text-xs-right">
                        <v-icon small color="grey">smartphone</v-icon>
                      </v-flex>
                      <v-flex xs8 justify-left>
                        <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                          {{ found.mobile }}
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout v-if="found.email !== null">
                      <v-flex xs2 class="text-xs-right">
                        <v-icon small color="grey">email</v-icon>
                      </v-flex>
                      <v-flex xs8 justify-left>
                        <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                          {{ found.email }}
                        </div>
                      </v-flex>
                    </v-layout>

                    <v-layout v-if="found.idNumber !== null">
                      <v-flex xs2 class="text-xs-right">
                        <v-icon small color="grey">perm_identity</v-icon>
                      </v-flex>
                      <v-flex xs8 justify-left>
                        <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                          {{ found.idNumber }}
                        </div>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </div>
              </v-flex>
            </v-layout>
          </div>
          <div v-else>
            <v-layout>
              <v-checkbox label="Create a new DataTill customer" v-model="createNewDatatillCustomer"></v-checkbox>
            </v-layout>
            <div v-if="createNewDatatillCustomer === true">
              <v-layout>
                <v-flex xs6 mx-3>
                  <v-autocomplete
                    xs6
                    :items="datatillContactTypeList"
                    label="Select contact to add to DataTill"
                    v-model="datatillContactType"
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs6 mx-3>
                  <v-card hover class="text-xs-center mb-2 mx-2">
                    <div class="primary subheading text-uppercase white--text">{{ datatillContactType }}</div>
                    <v-responsive></v-responsive>
                    <v-card-text>
                      <div class="subheading">{{ newCustomer.fullName }}</div>
                      <v-layout v-if="newCustomer.mobileNumber !== null">
                        <v-flex xs2 class="text-xs-right">
                          <v-icon small color="grey">smartphone</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                          <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                            {{ newCustomer.mobileNumber }}
                          </div>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="newCustomer.emailAddress !== null">
                        <v-flex xs2 class="text-xs-right">
                          <v-icon small color="grey">email</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                          <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                            {{ newCustomer.emailAddress }}
                          </div>
                        </v-flex>
                      </v-layout>

                      <v-layout v-if="newCustomer.idNumber !== null">
                        <v-flex xs2 class="text-xs-right">
                          <v-icon small color="grey">perm_identity</v-icon>
                        </v-flex>
                        <v-flex xs8 justify-left>
                          <div class="grey--text" style="text-overflow: ellipsis; overflow: hidden;">
                            {{ newCustomer.idNumber }}
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </div>
            <div v-else>
              <h3 style="color:grey">Please select a customer from the existing DataTill customers found</h3>
              <v-layout wrap>
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search2"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                  class="pa-3"
                  clearable
                ></v-text-field>
              </v-layout>
              <v-data-table
                v-model="selected"
                :rows-per-page-items="[10, 25, 50, 100]"
                :headers="customerSearchHeaders"
                :items="allCustomers"
                :pagination.sync="pagination"
                :search="search2"
                item-key="id"
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <tr :active="props.selected" @click="props.selected = !props.selected">
                    <td>
                      <v-checkbox
                        :input-value="props.selected"
                        primary
                        @click="selected = []"
                        hide-details
                      ></v-checkbox>
                    </td>

                    <td class="text-xs-center">{{ props.item.accounting_code }}</td>
                    <td class="text-xs-center">{{ props.item.contact_name }}</td>
                    <td class="text-xs-center">{{ props.item.contact_email }}</td>
                    <td class="text-xs-center">{{ props.item.contact_mobile }}</td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-layout>
            <v-spacer></v-spacer>
            <v-btn
              round
              color="primary"
              class="white--text"
              v-if="!existingDatatillCustomer && createNewDatatillCustomer && datatillContactType"
              @click="
                addCustomerModal = false;
                ispVerifyModal();
              "
              >NEXT</v-btn
            >
            <v-btn
              round
              color="primary"
              class="white--text"
              v-else-if="
                !existingDatatillCustomer && !createNewDatatillCustomer && applicationInfo.datatillCustomerId !== null
              "
              @click="
                addCustomerModal = false;
                ispVerifyModal();
              "
              >NEXT</v-btn
            >
            <v-btn
              round
              color="primary"
              class="white--text"
              v-else-if="existingDatatillCustomer && selectedExistingCustomer"
              @click="
                addCustomerModal = false;
                ispVerifyModal();
              "
              >NEXT</v-btn
            >
            <v-btn round color="primary" class="white--text" v-else disabled>NEXT</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="configModal" width="750px">
      <v-card color="white" flat>
        <v-toolbar color="primary" flat>
          <h3 class="title white--text">SERVICE CONFIGURATION</h3>
          <v-spacer></v-spacer>
          <v-btn color="white" flat @click="(configModal = false), (configurationSettings = {})">X</v-btn>
        </v-toolbar>
        <v-card-text>
          <div v-if="configurationSettings.type == 'Multiple'">
            <v-layout justify-center align-center wrap>
              <v-flex xs10 mx-1 my-1 v-if="configurationSettings.bridgeTemplates.length > 1">
                <h4 class="grey--text">
                  There are multiple configurations available for this device. Please choose the preferred
                  configuration:
                </h4>
              </v-flex>
              <v-flex xs8 mx-1 mt-2 v-for="template in configurationSettings.bridgeTemplates" :key="template.id">
                <v-card
                  color="white"
                  :hover="configurationSettings.selectedTemplateId !== template.id"
                  @click="
                    (configurationSettings.selectedTemplateId = template.id),
                      (configurationSettings.connectionType = template.connectionType)
                  "
                >
                  <v-toolbar
                    flat
                    :color="configurationSettings.selectedTemplateId == template.id ? 'light-green' : 'primary'"
                  >
                    <h3 class="title white--text" v-if="template.type == 'OneDevice'">One Device</h3>
                    <h3 class="title white--text" v-else>Two Device</h3>
                    <v-spacer></v-spacer>
                    <v-icon large v-if="configurationSettings.selectedTemplateId == template.id" color="white"
                      >check_circle</v-icon
                    >
                  </v-toolbar>
                  <v-card-text>
                    <v-layout justify-left align-center mx-1 wrap class="text-xs-left">
                      <v-flex xs4 mx-1>
                        <h3 class="grey--text">Connection Type:</h3>
                      </v-flex>
                      <v-flex xs4 mx-1>
                        <h3 class="grey--text font-weight-light">{{ template.connectionType }}</h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.innerVlan != 0">
                        <h3 class="grey--text">Inner VLAN:</h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.innerVlan != 0">
                        <h3 class="grey--text font-weight-light">{{ template.innerVlan }}</h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.outerVlan != 0">
                        <h3 class="grey--text">Outer VLAN:</h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.outerVlan != 0">
                        <h3 class="grey--text font-weight-light">{{ template.outerVlan }}</h3>
                      </v-flex>
                      <v-flex xs4 mx-1 v-if="template.type == 'TwoDevice'">
                        <h3 class="red--text">Terms:</h3>
                      </v-flex>
                      <v-flex xs6 mx-1 v-if="template.type == 'TwoDevice'">
                        <h3 class="red--text font-weight-light">
                          Second device is NOT provided by the network operator and will need to either be supplied by
                          the ISP or the end customer.
                        </h3>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </div>
          <div
            v-if="configurationSettings.connectionType && configurationSettings.connectionType.toLowerCase() == 'pppoe'"
          >
            <v-layout align-center justify-center wrap my-1>
              <v-flex xs10 mx-1 mt-2>
                <h3 class="title grey--text">PPPoE Configuration</h3>
              </v-flex>
              <v-flex xs4 mx-1>
                <v-text-field label="PPPoE Username" v-model="configurationSettings.pppoeUsername"></v-text-field>
              </v-flex>
              <v-flex xs4 mx-1>
                <v-text-field label="PPPoE Password" v-model="configurationSettings.pppoePassword"></v-text-field>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-layout justify-center align-center>
            <v-btn
              round
              color="primary"
              class="white--text"
              v-if="
                configurationSettings.selectedTemplateId &&
                  configurationSettings.connectionType &&
                  configurationSettings.connectionType.toLowerCase() != 'pppoe'
              "
              @click="submitConfiguration()"
              >Submit</v-btn
            >
            <v-btn
              round
              color="primary"
              class="white--text"
              v-else-if="
                configurationSettings.selectedTemplateId &&
                  configurationSettings.connectionType &&
                  configurationSettings.connectionType.toLowerCase() == 'pppoe' &&
                  configurationSettings.pppoeUsername &&
                  configurationSettings.pppoePassword
              "
              @click="submitConfiguration()"
              >Submit</v-btn
            >
            <v-btn round color="primary" class="white--text" v-else disabled>Submit</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Api from "@/services/Api";
import dateformat from "dateformat";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
export default {
  components: {
    VueCtkDateTimePicker: VueCtkDateTimePicker,
  },
  data() {
    return {
      commentArray: [],
      ticketCarousalArray: [],
      ticketIndex: 0,
      keepColorId: null,
      selectedExistingCustomer: null,
      datatillContactTypeList: [],
      allCustomers: [],
      selected: [],
      search2: "",
      customerSearchHeaders: [
        {
          text: "Action",
          align: "center",
          value: "action",
        },
        {
          text: "Code",
          align: "center",
          value: "accounting_code",
        },
        {
          text: "Name",
          align: "center",
          value: "contact_name",
        },
        {
          text: "Email Address",
          align: "center",
          value: "contact_email",
        },
        {
          text: "Mobile Number",
          align: "center",
          value: "contact_mobile",
        },
      ],
      addCustomerModal: false,
      foundExisting: [],
      newCustomer: {},
      datatillIntegration: false,
      datatillContactType: "",
      existingDatatillCustomer: false,
      createNewDatatillCustomer: true,
      applicationContactIndex: 0,
      snackbar: false,
      text: "",
      bridgeTemplates: [],
      connectionTypes: ["PPPoE", "IPoE"],
      configModal: false,
      configurationSettings: {},
      editedContact: {},
      editContactModal: false,
      invoiceNumberDialog: false,
      loadingApplication: false,
      addDeviceModal: [],
      xeroContacts: [],
      similarXeroContacts: [],
      addDeviceModal: false,
      installation: {},
      addInstallationModal: false,
      deniedReasonModal: false,
      applicationInfo: "",
      search: "",
      page: 1,
      allDevices: [],
      device: null,
      existingServiceAccounts: [],
      locationContacts: [],
      showApplicationContacts: true,
      showLocationContacts: false,
      linkedPrimaryContacts: [],
      linkedSecondaryContacts: [],
      deniedReason: "",
      linkedBillingContacts: [],
      similarContactsModalPrimary: false,
      similarContactsModalSecondary: false,
      similarContactsModalBilling: false,
      xeroContactsModal: false,
      billedXeroContactId: null,
      provisionTemplate: null,
      verifyingContact: false,
      verifyingInstallation: false,
      verifyingDevice: false,
      creatingPrimaryContact: false,
      creatingSecondaryContact: false,
      creatingBillingContact: false,
      allVlans: [],
      tickets: [],
      ticketItem: {},
      viewTicketModal: false,
      ticketCommentLog: [],
      ticketAssignedLog: [],
      deviceBridges: [],
      provisionWarningModal: false,
      ethPorts: [1, 2, 3, 4],
      changedPort: null,
      ticketKey: 0,
      dateTimeSelect: false,
      serviceAccountDetailsModal: false,
      y: "top",
      devicesLength: 0,
      pagination: { totalItems: 0 },
      tabs: [
        { name: "applicationContacts", displayName: "Application Contacts" },
        { name: "locationContacts", displayName: "Location Contacts" },
      ],
      locationTypeList: ["End Location", "Location Network", "Location Node", "Switching Centre"],
      locationType: "End Location",
      tributeOptions: { lookup: "name", values: this.users },
      addCommentBox: false,
      statuses: ["Incomplete", "Pending", "In Progress", "Complete"],
      importanceOptions: ["Normal", "Not Critical", "Average", "Urgent"],
      ticketCategoryItems: [],
      ticketCategories: [],
      comment: "",
      headers: [
        {
          text: "Action",
          align: "center",
        },
        {
          text: "System Name",
          align: "center",
          value: "systemName",
        },
        {
          text: "Location",
          align: "center",
          value: "location.locationDescription",
        },
        {
          text: "Network",
          align: "center",
          value: "locationNetwork.name",
        },
        {
          text: "Node",
          align: "center",
          value: "locationNode.name",
        },
        {
          text: "Switching Centre",
          align: "center",
          value: "switchingCentre.name",
        },
        {
          text: "Make",
          align: "center",
          value: "deviceMakeModel.deviceMake.name",
        },
        {
          text: "Type",
          align: "center",
          value: "deviceMakeModel.deviceType.name",
        },
        {
          text: "Model",
          align: "center",
          value: "deviceMakeModel.name",
        },
        {
          text: "IP Address",
          align: "center",
          value: "ipAddress",
        },
        {
          text: "Serial Number",
          align: "center",
          value: "serialNumber",
        },
        {
          text: "Pon Mac",
          align: "center",
          value: "ponMac",
        },
        {
          text: "Mac Address",
          align: "center",
          value: "macAddress",
        },
        {
          text: "Pon Numerical",
          align: "center",
          value: "ponNumerical",
        },
        {
          text: "Product Number",
          align: "center",
          value: "productNumber",
        },

        {
          text: "Upstream Device",
          align: "center",
          value: "upstreamDevice.deviceMakeModel.name",
        },
        {
          text: "PON Address",
          align: "center",
          value: "ponAddress",
        },
        {
          text: "PON ID",
          align: "center",
          value: "ponId",
        },
        {
          text: "Frame",
          align: "center",
          value: "frame",
        },
        {
          text: "Slot",
          align: "center",
          value: "slot",
        },
        {
          text: "Port",
          align: "center",
          value: "port",
        },
        {
          text: "Note",
          align: "center",
          value: "note",
        },
        {
          text: "Active",
          align: "center",
          value: "isActive",
        },
      ],
    };
  },
  async created() {
    let route = await this.$store.state.currentOrg.org.permissions.filter(function(el) {
      return el.url === "/ispApplications/:applicationId";
    });
    if (route.length > 0) {
      await this.$store.dispatch("setCurrentRoute", route[0]);
      if ((await this.authRead(this.$store.state.currentRoute)) === true) {
        // this.$router.push({
        //   name: this.$route.name,
        //   query: { offset: "0", records: "10" }
        // });
        this.initialize();
      }
    } else {
      this.$router.push({ name: "SplashPage" });
    }
  },
  computed: {
formattedAddress(){
      let address = ''
      if(this.applicationInfo.unitNo){
        address += 'Unit '+this.applicationInfo.unitNo +', '
      }
      if(this.applicationInfo.floorNo){
        address += 'Floor '+this.applicationInfo.floorNo +', '
      }
      if(this.applicationInfo.building){
        address += this.applicationInfo.building +', '
      }
      if(this.applicationInfo.streetNumber){
        address += this.applicationInfo.streetNumber +' '
      }
      if(this.applicationInfo.streetName){
        address += this.applicationInfo.streetName +', '
      }
      if(this.applicationInfo.suburb){
        address += this.applicationInfo.suburb +', '
      }
      if(this.applicationInfo.town){
        address +=this.applicationInfo.town +', '
      }
      if(this.applicationInfo.province){
        address += this.applicationInfo.province +', '
      }
      if(this.applicationInfo.country){
        address += this.applicationInfo.country
      }
      if(this.applicationInfo.postalCode){
        address +=  ' ' + this.applicationInfo.postalCode
      }
      return address
    }
  },
  watch: {
    "$vuetify.breakpoint.lgAndDown": {
      immediate: true,
      async handler(value) {
        console.log(value);
        if (value && value !== null) {
          this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 1);
        } else {
          this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 2);
        }
      },
    },
    "$route.query.search": {
      immediate: true,
      handler(value) {
        // this.devices= await this.search(value.search)
        this.isLoading = true;
        if (this.$route.query.search && value !== "" && value != null) {
          // debugger
          Api()
            .get("/devices/active", {
              params: {
                search: value,
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allDevices = response.data.result;
              this.pagination.totalItems = response.data.count;
              this.devicesLength = response.data.count;
              this.isLoading = false;
            });
        } else if (this.$route.query.offset && this.$route.query.records) {
          // debugger
          Api()
            .get("/devices/active", {
              params: {
                offset: "0",
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allDevices = response.data.result;
              this.pagination.totalItems = response.data.count;
              this.devicesLength = response.data.count;
              this.isLoading = false;
            });
          // this.fetchDevices()
          // // debugger
        }
      },
    },
    "$route.query.offset": {
      immediate: true,
      handler(value) {
        this.isLoading = true;
        if (
          value !== "" &&
          value != null &&
          this.$route.query.search &&
          this.$route.query.search != "" &&
          this.$route.query.search !== null
        ) {
          Api()
            .get("/devices/active", {
              params: {
                search: this.$route.query.search,
                offset: this.$route.query.offset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.devices = response.data;
              this.devicesLength = this.devices.length;
              this.isLoading = false;
            });
        } else if (value !== "" && value != null) {
          Api()
            .get("/devices/active", {
              params: {
                offset: this.$route.query.offset,
                records: this.$route.query.records,
              },
            })
            .then((response) => {
              this.allDevices = response.data.result;
              this.pagination.totalItems = response.data.count;
              this.devicesLength = response.data.count;
              this.isLoading = false;
            });
        }
      },
    },
    page(value) {
      this.pagination.page = this.page;
      if (value && value != "" && value != this.$route.query.records) {
        if (this.$route.query.search) {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
              search: this.$route.query.search,
            },
          });
        } else {
          this.$router.push({
            name: this.$route.name,
            query: {
              offset: (value - 1) * this.$route.query.records,
              records: this.$route.query.records,
            },
          });
        }
      }
    },
    datatillContactType(value) {
      if (value === "Primary") {
        this.newCustomer.fullName =
          this.applicationInfo.primaryContactFirstname + " " + this.applicationInfo.primaryContactLastname;
        this.newCustomer.idNumber = this.applicationInfo.primaryContactIdNumber;
        this.newCustomer.mobileNumber = this.applicationInfo.primaryContactMobileNumber;
        this.newCustomer.telephoneNumber = this.applicationInfo.primaryContactMobileNumber;
        this.newCustomer.emailAddress = this.applicationInfo.primaryContactEmailAddress;
      } else if (value === "Secondary") {
        this.newCustomer.fullName =
          this.applicationInfo.secondaryContactFirstname + " " + this.applicationInfo.secondaryContactLastname;
        this.newCustomer.idNumber = this.applicationInfo.secondaryContactIdNumber;
        this.newCustomer.mobileNumber = this.applicationInfo.secondaryContactMobileNumber;
        this.newCustomer.telephoneNumber = this.applicationInfo.secondaryContactMobileNumber;
        this.newCustomer.emailAddress = this.applicationInfo.secondaryContactEmailAddress;
      } else if (value === "Billing") {
        this.newCustomer.fullName =
          this.applicationInfo.billingContactFirstname + " " + this.applicationInfo.billingContactLastname;
        this.newCustomer.idNumber = this.applicationInfo.billingContactIdNumber;
        this.newCustomer.mobileNumber = this.applicationInfo.billingContactMobileNumber;
        this.newCustomer.telephoneNumber = this.applicationInfo.billingContactMobileNumber;
        this.newCustomer.emailAddress = this.applicationInfo.billingContactEmailAddress;
      }
      console.log(this.newCustomer);
    },
    selected(value) {
      this.applicationInfo.datatillCustomerId = value.id;

      console.log(value);
    },
  },
  methods: {
    backTicketArrow() {
      this.ticketIndex--;
      if (this.$vuetify.breakpoint.lgAndDown) {
        this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 1);
      } else {
        this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 2);
      }

      this.ticketKey++;
    },
    forwardTicketArrow() {
      this.ticketIndex++;
      if (this.$vuetify.breakpoint.lgAndDown) {
        this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 1);
      } else {
        this.ticketCarousalArray = this.tickets.slice(this.ticketIndex, this.ticketIndex + 2);
      }

      this.ticketKey++;
    },
    clearIntegrationFields() {
      this.selected = [];
      this.datatillContactType = "Primary";
      (this.selectedExistingCustomer = null), (this.createNewDatatillCustomer = true);
    },
    clearPackageSelection() {
      let elements = document.getElementsByName("packageCard");
      for (let i = 0; i < elements.length; i++) {
        elements[i].style.border = "none";
        elements[i].style.backgroundColor = "white";
      }
    },
    selectExistingCustomer(pack) {
      this.clearPackageSelection();
      if (this.selectedExistingCustomer === null) {
        this.selectedExistingCustomer = pack;
        this.keepColorId = pack.customerId;

        document.getElementById(pack.customerId).style.backgroundColor = "#e6e6e6";
        document.getElementById(pack.customerId).style.border = "1px solid #99cc33";
      } else {
        if (pack.customerId != this.selectedExistingCustomer.customerId) {
          this.selectedExistingCustomer = pack;
          this.keepColorId = pack.customerId;

          document.getElementById(pack.customerId).style.backgroundColor = "#e6e6e6";
          document.getElementById(pack.customerId).style.border = "1px solid #99cc33";
        } else if (pack.customerId == this.selectedExistingCustomer.customerId) {
          this.selectedExistingCustomer = null;
          this.keepColorId = null;
        }
      }
      console.log(this.selectedExistingCustomer);
    },
    submitApproval() {
      confirm("Are you sure you would like to confirm receipt of this application?") &&
        Api()
          .put("/customer/applications/" + this.$route.params.applicationId, {
            ispVerified: true,
            ispVerifiedById: this.$store.state.user.id,
            ispVerifiedDate: new Date(),
            ispAccepted: true,
            serviceAccountType: this.applicationInfo.serviceAccountType,
            pppoeUsername: this.applicationInfo.pppoeUsername,
            pppoePassword: this.applicationInfo.pppoePassword,
          })
          .then((response) => {
            this.serviceAccountDetailsModal = false;
            (this.applicationInfo.ispVerified = true),
              (this.applicationInfo.ispAccepted = true),
              (this.applicationInfo.ispVerifiedDate = new Date()),
              (this.applicationInfo.ispVerifiedById = this.$store.state.user.id),
              (this.applicationInfo.ispVerifiedBy = this.$store.state.user);
          });
    },
    ispVerifyModal() {
      if (this.bridgeTemplates.length == 0) {
        confirm(
          "You do not have any configuration templates for this make. Please set this up with the relevant Fibre Network Operator."
        );
      } else {
        if (this.device) {
          let selectedTemplates = [];
          if (this.device.deviceMakeModel.oneDevicePolicy && this.device.deviceMakeModel.twoDevicePolicy) {
            selectedTemplates = this.bridgeTemplates.filter((x) => x.type == "OneDevice" || x.type == "TwoDevice");
          } else if (this.device.deviceMakeModel.oneDevicePolicy && !this.device.deviceMakeModel.twoDevicePolicy) {
            selectedTemplates = this.bridgeTemplates.filter((x) => x.type == "OneDevice");
          } else if (!this.device.deviceMakeModel.oneDevicePolicy && this.device.deviceMakeModel.twoDevicePolicy) {
            selectedTemplates = this.bridgeTemplates.filter((x) => x.type == "TwoDevice");
          }
          if (selectedTemplates.length == 0) {
            confirm(
              "You do not have any configuration templates that match the available policies for this device model. Please contact the Fibre Network Operator to rectify this issue."
            );
          } else {
            if (selectedTemplates.length > 0) {
              this.configurationSettings = {
                type: "Multiple",
                bridgeTemplates: selectedTemplates,
                selectedTemplateId: selectedTemplates[0].id,
                connectionType: selectedTemplates[0].connectionType,
              };
              if (selectedTemplates.length > 1 || this.configurationSettings.connectionType.toLowerCase() == "pppoe") {
                this.configModal = true;
              } else {
                this.submitConfiguration();
              }
            }
          }
        }
      }
    },
    submitConfiguration() {
      confirm("Are you sure you would like to confirm receipt of this application?") &&
        Api()
          .put("/customer/applications/" + this.$route.params.applicationId, {
            ispVerified: true,
            ispVerifiedById: this.$store.state.user.id,
            ispVerifiedDate: new Date(),
            ispAccepted: true,
            organisationBridgeTemplateId: this.configurationSettings.selectedTemplateId,
            serviceAccountType: this.configurationSettings.connectionType,
            pppoeUsername: this.configurationSettings.pppoeUsername,
            pppoePassword: this.configurationSettings.pppoePassword,
          })
          .then((response) => {
            if (this.datatillIntegration) {
              if (this.existingDatatillCustomer === true) {
                Api().put("/customer/applications/" + this.$route.params.applicationId, {
                  datatillCustomerId: this.selectedExistingCustomer.customerId,
                });
              } else {
                if (this.createNewDatatillCustomer) {
                  Api()
                    .post("/datatill/addCustomer", {
                      organisationId: this.$store.state.currentOrg.org.id,
                      idNumber: this.newCustomer.idNumber,
                      name: this.newCustomer.fullName,
                      telephoneNumber: this.newCustomer.telephoneNumber,
                      mobileNumber: this.newCustomer.mobileNumber,
                      emailAddress: this.newCustomer.emailAddress,
                      physicalAddress: this.applicationInfo.location.locationDescription,
                      postalAddress: this.applicationInfo.location.locationDescription,
                    })
                    .then((response) => {
                      Api().put("/customer/applications/" + this.$route.params.applicationId, {
                        datatillCustomerId: response.data.customerId,
                      });
                    });
                } else {
                  Api().put("/customer/applications/" + this.$route.params.applicationId, {
                    datatillCustomerId: this.applicationInfo.datatillCustomerId,
                  });
                }
              }
            }

            this.notifyFno();
            this.configModal = false;
            (this.applicationInfo.ispVerified = true),
              (this.applicationInfo.ispAccepted = true),
              (this.applicationInfo.ispVerifiedDate = new Date()),
              (this.applicationInfo.ispVerifiedById = this.$store.state.user.id),
              (this.applicationInfo.ispVerifiedBy = this.$store.state.user);
          });
    },
    selectDevice(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (this.applicationInfo.passiveInstallComplete) {
          confirm("Are you sure you would like to add this device to the location?") &&
            Api()
              .get("/devices/" + item.id)
              .then((response) => {
                this.device = response.data;
                Api()
                  .put("/locations/" + this.applicationInfo.locationId, {
                    equipmentInstalled: true,
                  })
                  .then((response) => {
                    this.applicationInfo.location.equipmentInstalled = true;
                  });
                Api().put("/devices/" + item.id, {
                  locationId: this.applicationInfo.locationId,
                });
                if (this.applicationInfo.serviceAccountId !== null) {
                  Api().put("/serviceAccounts/" + this.applicationInfo.serviceAccountId, {
                    deviceId: item.id,
                  });
                }
              });
        } else {
          confirm("There is currently no passive installation for this location. Would you like to add one now?") &&
            this.generatePassiveInstall();
          confirm("Are you sure you would like to add this device to the location?") &&
            Api()
              .get("/devices/" + item.id)
              .then((response) => {
                this.device = response.data;
                Api()
                  .put("/locations/" + this.applicationInfo.locationId, {
                    equipmentInstalled: true,
                  })
                  .then((response) => {
                    this.applicationInfo.location.equipmentInstalled = true;
                  });
                Api().put("/devices/" + item.id, {
                  locationId: this.applicationInfo.locationId,
                });
                if (this.applicationInfo.serviceAccountId !== null) {
                  Api().put("/serviceAccounts/" + this.applicationInfo.serviceAccountId, {
                    deviceId: item.id,
                  });
                }
                this.addDeviceModal = false;
              });
        }
      }
    },
    async deviceCount() {
      Api()
        .get("/devices/active/count")
        .then((response) => {
          this.devicesLength = response.data.count;
          this.pagination.totalItems = this.devicesLength;
        });
    },
    removeContact(item) {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        Api()
          .put("/LocationContact/" + item.id, {
            isDeleted: true,
            isActive: false,
          })
          .then((response) => {
            (item.isActive = false), (item.isDeleted = true);
          });
        let index = this.locationContacts.indexOf(item);
        this.locationContacts.splice(index, 1);
        if (!this.locationContacts.length > 0) {
          this.showApplicationContacts = true;
          this.showLocationContacts = false;
        }
      }
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },
    formatDate(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd");
      } else {
        null;
      }
    },
    processPortChange() {
      if (this.provisionTemplate != null) {
        this.provisionTemplate.tpIndex = this.changedPort;
        let ponId = this.provisionTemplate.gponOnuId.toString();
        if (this.provisionTemplate.gponOnuId < 10) {
          ponId = "0" + ponId;
        }

        if (!this.provisionTemplate.autoSelectGemPortValue) {
          this.provisionTemplate.gponPortId = "3" + this.provisionTemplate.tpIndex.toString() + ponId;
        } else {
          this.provisionTemplate.gponPortId = 0;
        }
        this.changedPort = null;
        this.provisionWarningModal = false;
        this.approveApplication();
      }
    },
    filterByValue(array, string) {
      return array.filter((o) => {
        return Object.keys(o).some((k) => {
          if (typeof o[k] === "string") return o[k].toLowerCase().includes(string.toLowerCase());
        });
      });
    },
    async fetchXeroContacts() {
      await Api()
        .get("/xero/allContacts")
        .then((response) => {
          this.xeroContacts = response.data;
        });
    },
    async findSimilarContacts(contact, name, email) {
      let similarContacts = [];
      let similarNames = await this.filterByValue(this.xeroContacts, name);
      for (let a = 0; a < similarNames.length; a++) {
        let match = (await Math.round(this.similarity(name, similarNames[a].Name) * 10000)) / 100;
        await similarContacts.push({
          xeroContactId: similarNames[a].ContactID,
          match: match,
          name: similarNames[a].Name,
          email: similarNames[a].EmailAddress,
        });
      }
      this.similarXeroContacts = similarContacts;
      if (this.similarXeroContacts.length > 0) {
        this.xeroContactsModal = true;
      } else {
        this.xeroContactsModal = false;
        confirm(
          "Are you sure you would like to generate the invoice for " + contact.name + " " + contact.surname + "?"
        ) && this.generateXeroInvoice(contact);
      }
    },

    createXeroContact() {
      let contact = null;
      let taxNumber = null;
      if (this.applicationInfo.billingContactId !== null) {
        contact = this.applicationInfo.billingContact;
      } else if (this.applicationInfo.primaryContactId !== null) {
        contact = this.applicationInfo.primaryContact;
      }
      if (this.applicationInfo.billingContactId !== null && this.applicationInfo.billingContactVatNumber !== null) {
        taxNumber = null;
      } else {
        taxNumber = this.applicationInfo.billingContactVatNumber;
      }
      Api()
        .post("/xero/contact", {
          Name: contact.name + " " + contact.surname,
          FirstName: contact.name,
          LastName: contact.surname,
          EmailAddress: contact.emailAddress,
          ContactStatus: "ACTIVE",
          ContactID:
            this.makeContactId(8).toString() +
            "-" +
            this.makeContactId(4).toString() +
            "-" +
            this.makeContactId(4).toString() +
            "-" +
            this.makeContactId(4).toString() +
            "-" +
            this.makeContactId(8).toString(),
          //  00000000-0000-0000-0000-000000000000
          TaxNumber: this.applicationInfo.billingContactVatNumber,
          Addresses: [
            {
              AddressLine1: this.applicationInfo.location.locationDescription,
              AddressLine2: this.applicationInfo.location.locationNetwork.streetName,
              AddressLine3: this.applicationInfo.location.locationNetwork.suburb,
              AddressLine3: this.applicationInfo.location.locationNetwork.town,
              City: this.applicationInfo.location.locationNetwork.city,
              Country: this.applicationInfo.location.locationNetwork.country,
            },
          ],
        })
        .then((response) => {
          console.log(response.data);
        });
    },
    makeContactId(length) {
      var result = "";
      var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      var charactersLength = characters.length;
      for (var i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
      }
      return result;
    },
    similarity(s1, s2) {
      var longer = s1;
      var shorter = s2;
      if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
      }
      var longerLength = longer.length;
      if (longerLength == 0) {
        return 1.0;
      }
      return (longerLength - this.editDistance(longer, shorter)) / parseFloat(longerLength);
    },
    editDistance(s1, s2) {
      s1 = s1.toLowerCase();
      s2 = s2.toLowerCase();

      var costs = new Array();
      for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
          if (i == 0) costs[j] = j;
          else {
            if (j > 0) {
              var newValue = costs[j - 1];
              if (s1.charAt(i - 1) != s2.charAt(j - 1))
                newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
              costs[j - 1] = lastValue;
              lastValue = newValue;
            }
          }
        }
        if (i > 0) costs[s2.length] = lastValue;
      }
      return costs[s2.length];
    },

    async initialize() {
      await this.getApplication();
      this.getExistingServiceAccounts();
      this.fetchTickets();
      // this.fetchAllVlans();
      // this.fetchAllDevices();
      // if(this.applicationInfo.routerInstallationFee>0||this.applicationInfo.gtuInstallationFee>0){
      //   await this.fetchXeroContacts()
      // }

      // if (this.applicationInfo.packagesIspId !== null && this.device !== null && (this.$store.state.currentOrg.org.zhoneIntegration || this.$store.state.currentOrg.org.acsIntegration)) {
      //   this.getAvailableTemplates(
      //     this.device.deviceMakeModel.deviceMakeId
      //   );
      //   this.fetchDeviceBridges(this.device.id);
      // }
      this.fetchApplicationComments();
      this.fetchTicketCategories();
      this.fetchTicketCategoryItems();
      if (this.applicationInfo.packagesIsp && this.applicationInfo.packagesIsp.datatillProductId) {
        this.checkDatatillIntegration();
      }
      // this.deviceCount();
    },
    async addApplicationComment(comment) {
      comment = comment.replace(/<div>/g, "");
      comment = comment.replace("</div>", "");
      comment = comment.replace(/<br>/g, "");
      Api()
        .post("/applicationComment", {
          isInternal: false,
          applicationId: parseInt(this.$route.params.applicationId),
          type: "comment",
          commentedById: this.$store.state.user.id,
          comment: comment,
        })
        .then((response) => {
          this.notifyIsp();
          this.notifyFno();
          this.comment = "";
          this.fetchApplicationComments();
        });
    },
    fetchApplicationComments() {
      this.commentArray = [];

      Api()
        .get("/applicationComment/customer/byApplication/" + this.$route.params.applicationId)
        .then(async (response) => {
          console.log(response.data);
          await response.data.map((x) => {
            this.commentArray.push({
              commentedById: x.commentedById,
              commentedByName: x.commentedBy.name,
              commentedBySurname: x.commentedBy.surname,
              comment: x.comment,
              type: x.type,
              createdAt: x.createdAt,
              id: x.id,
              commentLogType: true,
            });
          });
          this.commentArray.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        });
    },
    checkDatatillIntegration() {
      Api()
        .get("/integrations/byName/Datatill")
        .then((response) => {
          if (response.data) {
            this.datatillIntegration = true;
            this.fetchDatatillCustomer();
          }
          console.log(response.data);
        });
    },
    fetchDatatillCustomer() {
      this.datatillContactType = "Primary";
      this.datatillContactTypeList = [];
      if (this.applicationInfo.primaryContactEmailAddress) {
        this.datatillContactTypeList.push("Primary");
      }
      if (this.applicationInfo.secondaryContactEmailAddress) {
        this.datatillContactTypeList.push("Secondary");
      }
      if (this.applicationInfo.billingContactEmailAddress) {
        this.datatillContactTypeList.push("Billing");
      }
      Api()
        .post("/datatill/customerList", {
          organisationId: this.$store.state.currentOrg.org.id,
          primaryContactEmail: this.applicationInfo.primaryContactEmailAddress,
          secondaryContactEmail: this.applicationInfo.secondaryContactEmailAddress,
          billingContactEmail: this.applicationInfo.billingContactEmailAddress,
          // contactEmail: 'cornelis.vanrensburg@gmail.com'
        })
        .then((response) => {
          this.allCustomers = response.data.allCustomers;
          this.foundExisting = [];
          if (response.data.primaryCustomerId !== null) {
            this.foundExisting.push({
              type: "Primary",
              customerId: response.data.primaryCustomerId,
              fullName:
                this.applicationInfo.primaryContactTitle +
                " " +
                this.applicationInfo.primaryContactFirstname +
                " " +
                this.applicationInfo.primaryContactLastname,
              email: this.applicationInfo.primaryContactEmailAddress,
              mobile: this.applicationInfo.primaryContactMobileNumber,
              idNumber: this.applicationInfo.primaryContactIdNumber,
            });
            // this.applicationInfo.datatillCustomerId = response.data.customerId
            this.existingDatatillCustomer = true;
          }
          if (response.data.secondaryCustomerId !== null) {
            this.foundExisting.push({
              type: "Secondary",
              customerId: response.data.secondaryCustomerId,
              fullName:
                this.applicationInfo.secondaryContactTitle +
                " " +
                this.applicationInfo.secondaryContactFirstname +
                " " +
                this.applicationInfo.secondaryContactLastname,
              email: this.applicationInfo.secondaryContactEmailAddress,
              mobile: this.applicationInfo.secondaryContactMobileNumber,
              idNumber: this.applicationInfo.secondaryContactIdNumber,
            });
            this.existingDatatillCustomer = true;
          }
          if (response.data.billingCustomerId !== null) {
            this.foundExisting.push({
              type: "Billing",
              customerId: response.data.billingCustomerId,
              fullName:
                this.applicationInfo.billingContactTitle +
                " " +
                this.applicationInfo.billingContactFirstname +
                " " +
                this.applicationInfo.billingContactLastname,
              email: this.applicationInfo.billingContactEmailAddress,
              mobile: this.applicationInfo.billingContactMobileNumber,
              idNumber: this.applicationInfo.billingContactIdNumber,
            });
            this.existingDatatillCustomer = true;
          }
          console.log(response.data);
        });
    },
    fetchDeviceBridges(id) {
      Api()
        .get("/deviceBridge/" + id)
        .then((response) => {
          this.deviceBridges = response.data;
        });
    },
    fetchTicketCategories() {
      Api()
        .get("/ticketCategory")
        .then((response) => {
          this.ticketCategories = response.data;
        });
    },
    fetchTicketCategoryItems() {
      Api()
        .get("/ticketCategoryItem")
        .then((response) => {
          this.ticketCategoryItems = response.data;
          this.ticketKey += 1;
        });
    },
    async routeToTicketSummary(id) {
      // if(customerOrganisationId===this.$store.state.currentOrg.org.id){
      this.$router.push({ path: "/ispTicketSummary/" + id });
      // let route = await this.$store.state.currentOrg.org.permissions.filter(function(el){
      //   return el.url === '/ispTicketSummary/:ticketId'})
      // await this.$store.dispatch('setCurrentRoute', route[0])
      // this.$router.push({ path: "/ispTicketSummary/" + id });
      // }else{
      //   confirm("You do not have permission to view these ticket details. Please contact your Organisation Administrator for further assistance.")
      // }
    },
    addCommentEditedTicket(comment) {
      Api()
        .post("/ticketComment", {
          ticketId: this.ticketItem.id,
          type: "comment",
          commentedById: this.$store.state.user.id,
          comment: comment,
        })
        .then((response) => {
          response.data.commentedBy = this.$store.state.user;
          this.ticketCommentLog.push(response.data);
          this.comment = "";
          this.addCommentBox = false;
        });
    },
    async fetchTickets() {
      await Api()
        .get("/allTickets/byApplication/customer/" + this.$route.params.applicationId)
        .then((response) => {
          this.tickets = response.data;
          let temp = response.data;
          this.ticketCarousalArray = temp.slice(0, 2);
        });
    },
    async getAvailableTemplates(deviceMakeId) {
      Api()
        .get(
          "/customer/organisationBridgeTemplate/byCustomerDeviceMake/" +
            deviceMakeId +
            "/" +
            this.applicationInfo.supplierOrganisationId
        )
        .then((response) => {
          this.bridgeTemplates = response.data;
          // if(response.data){
          //    this.provisionTemplate = response.data;
          // if(this.device.deviceMakeModel.deviceMake.name.toLowerCase()=='zhone'){
          //   if (this.provisionTemplate != null) {
          //   this.provisionTemplate.uploadSpeed = this.applicationInfo.packagesIsp.packagesFno.speedProfile.uploadMbps;
          //   this.provisionTemplate.downloadSpeed = this.applicationInfo.packagesIsp.packagesFno.speedProfile.downloadMbps;
          //   this.provisionTemplate.Device_ID = this.device.Device_ID;
          //   this.provisionTemplate.gponSlotId = this.device.gponSlotId;
          //   this.provisionTemplate.gponOltId = this.device.gponOltId;
          //   this.provisionTemplate.gponOnuId = this.device.gponOnuId;
          //   this.provisionTemplate.deviceId = this.device.id;

          //   let ponId = this.device.gponOnuId.toString();
          //   if (this.device.gponOnuId < 10) {
          //     ponId = "0" + ponId;
          //   }

          //   if (!this.provisionTemplate.autoSelectGemPortValue) {
          //     this.provisionTemplate.gponPortId =
          //       "3" + this.provisionTemplate.tpIndex.toString() + ponId;
          //   } else {
          //     this.provisionTemplate.gponPortId = 0;
          //   }
          // }
          // } else {
          //   this.provisionTemplate.uploadSpeed = this.applicationInfo.packagesIsp.packagesFno.speedProfile.uploadMbps;
          //   this.provisionTemplate.downloadSpeed = this.applicationInfo.packagesIsp.packagesFno.speedProfile.downloadMbps;
          //   this.provisionTemplate.Device_ID = this.device.Device_ID;
          //   this.provisionTemplate.gponSlotId = this.device.gponSlotId;
          //   this.provisionTemplate.gponOltId = this.device.gponOltId;
          //   this.provisionTemplate.gponOnuId = this.device.gponOnuId;
          //   this.provisionTemplate.deviceId = this.device.id;
          // }

          // }
        });
    },
    async createInvoiceItem() {
      if (this.authCreate(this.$store.state.currentRoute)) {
        if (this.applicationInfo.billingContactId === null && this.applicationInfo.primaryContactId === null) {
          confirm("Please first create either the primary or billing contact.");
        } else {
          let contact = null;
          if (this.applicationInfo.billingContactId !== null) {
            contact = this.applicationInfo.billingContact;
            await this.findSimilarContacts(
              contact,
              this.applicationInfo.billingContact.name + " " + this.applicationInfo.billingContact.surname,
              this.applicationInfo.billingContact.emailAddress
            );
          } else {
            contact = this.applicationInfo.primaryContact;
            await this.findSimilarContacts(
              contact,
              this.applicationInfo.primaryContact.name + " " + this.applicationInfo.primaryContact.surname,
              this.applicationInfo.primaryContact.emailAddress
            );
          }
        }
      }
    },
    provisionAccount() {
      if (
        this.provisionTemplate != null &&
        this.deviceBridges.length > 0 &&
        this.deviceBridges.map((x) => x.tpIndex).includes(parseInt(this.provisionTemplate.tpIndex))
      ) {
        return false;
      } else {
        //  this.createServiceAccount()
        return true;
      }
    },
    async generateXeroInvoice() {
      // await this.createXeroContact()
      let contact = null;
      let taxNumber = null;
      let lineItems = [];
      if (this.applicationInfo.billingContactId !== null) {
        contact = this.applicationInfo.billingContact;
      } else if (this.applicationInfo.primaryContactId !== null) {
        contact = this.applicationInfo.primaryContact;
      }
      if (this.applicationInfo.billingVatNumber !== null) {
        taxNumber = this.applicationInfo.billingVatNumber;
      }
      if (this.applicationInfo.routerInstallationFee > 0) {
        await lineItems.push({
          Description: "FTTH Installation Fee",
          AccountCode: "INS",
          Quantity: 1,
          UnitAmount: this.applicationInfo.routerInstallationFee,
        });
      }
      if (this.applicationInfo.gtuInstallationFee > 0) {
        await lineItems.push({
          Description: "GTU Installation Fee",
          AccountCode: "211",
          Quantity: 1,
          UnitAmount: this.applicationInfo.gtuInstallationFee,
        });
      }
      let date = new Date();
      Api()
        .post("/xero/invoice", {
          Type: "ACCREC",
          Contact: {
            Name: contact.name + " " + contact.surname,
            FirstName: contact.name,
            LastName: contact.surname,
            EmailAddress: contact.emailAddress,
            // EmailAddress: 'jarryd@dotparse.com',
            ContactStatus: "ACTIVE",
            TaxNumber: taxNumber,
            Addresses: [
              {
                AddressLine1: this.applicationInfo.location.locationDescription,
                AddressLine2: this.applicationInfo.location.locationNetwork.streetName,
                AddressLine3: this.applicationInfo.location.locationNetwork.suburb,
                AddressLine3: this.applicationInfo.location.locationNetwork.town,
                City: this.applicationInfo.location.locationNetwork.city,
                Country: this.applicationInfo.location.locationNetwork.country,
              },
            ],
          },
          Reference: "FTTH Installation",
          Date: date,
          DueDate: date,
          LineAmountTypes: "Inclusive",
          LineItems: lineItems,
        })
        .then(async (response) => {
          if (response.status === 200) {
            this.snackbar = true;
            this.text = "Invoice successfully created!";
          }
          this.applicationInfo.invoiceNumber = response.data[0].invoiceNumber;
          this.applicationInfo.isInvoiced = true;
          await Api().put("/applications/" + this.applicationInfo.id, {
            isInvoiced: true,
            invoiceNumber: response.data[0].InvoiceNumber,
          });
          // await Api()
          // .post('/xero/emailInvoice',{
          //   InvoiceID: response.data[0].InvoiceID
          // }).then(response=>{
          //     this.snackbar=true
          //     this.text="Invoice successfully sent via email!"
          // })
          let transactionPost = [];
          if (this.applicationInfo.routerInstallationFee > 0) {
            await transactionPost.push({
              date: new Date(),
              description: "Router Installation",
              xeroCode: "1",
              amount: this.applicationInfo.routerInstallationFee / (1 + $VAT),
              isRecurring: false,
              transactionType: "Sales",
              locationId: this.applicationInfo.locationId,
              locationNetworkId: this.applicationInfo.location.locationNetworkId,
              locationNodeId: this.applicationInfo.location.locationNetwork.locationNodeId,
              isActive: true,
              isDeleted: false,
            });
          }
          if (this.applicationInfo.hasTvOverFibre && this.applicationInfo.gtuInstallationFee > 0) {
            await transactionPost.push({
              date: new Date(),
              description: "GTU Installation",
              xeroCode: "1",
              amount: this.applicationInfo.gtuInstallationFee / (1 + $VAT),
              isRecurring: false,
              transactionType: "Sales",
              locationId: this.applicationInfo.locationId,
              locationNetworkId: this.applicationInfo.location.locationNetworkId,
              locationNodeId: this.applicationInfo.location.locationNetwork.locationNodeId,
              isActive: true,
              isDeleted: false,
            });
          }
          await Api().post("/transactions/bulk", {
            batch: transactionPost,
          });
          this.initialize();
        });
    },

    changeInvoiceStatus() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (!this.applicationInfo.isInvoiced) {
          this.invoiceNumberDialog = true;
        } else {
          this.saveInvoiceStatus();
        }
      }
    },
    saveInvoiceStatus() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to change the invoiced status?") &&
          Api()
            .put("/applications/" + this.$route.params.applicationId, {
              isInvoiced: !this.applicationInfo.isInvoiced,
            })
            .then((response) => {
              if (response.data.isInvoiced === false) {
                this.applicationInfo.invoiceNumber = "";
                Api().put("/applications/" + this.$route.params.applicationId, {
                  invoiceNumber: this.applicationInfo.invoiceNumber,
                });
              }
              this.applicationInfo.isInvoiced = !this.applicationInfo.isInvoiced;
              this.invoiceNumberDialog = false;
            });
      }
    },
    async changePaidStatus() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to change the paid status? WARNING: This step is not reversible.") &&
          Api()
            .put("/applications/" + this.$route.params.applicationId, {
              isPaid: true,
            })
            .then(async (response) => {
              this.applicationInfo.isPaid = true;
              let transactionPost = [];
              if (this.applicationInfo.routerInstallationFee > 0) {
                await transactionPost.push({
                  date: new Date(),
                  description: "Router Installation",
                  xeroCode: "1",
                  amount: this.applicationInfo.routerInstallationFee / (1 + $VAT),
                  isRecurring: false,
                  transactionType: "Sales",
                  locationId: this.applicationInfo.locationId,
                  locationNetworkId: this.applicationInfo.location.locationNetworkId,
                  locationNodeId: this.applicationInfo.location.locationNetwork.locationNodeId,
                  isActive: true,
                  isDeleted: false,
                });
              }
              if (this.applicationInfo.hasTvOverFibre && this.applicationInfo.gtuInstallationFee > 0) {
                await transactionPost.push({
                  date: new Date(),
                  description: "GTU Installation",
                  xeroCode: "1",
                  amount: this.applicationInfo.gtuInstallationFee / (1 + $VAT),
                  isRecurring: false,
                  transactionType: "Sales",
                  locationId: this.applicationInfo.locationId,
                  locationNetworkId: this.applicationInfo.location.locationNetworkId,
                  locationNodeId: this.applicationInfo.location.locationNetwork.locationNodeId,
                  isActive: true,
                  isDeleted: false,
                });
              }
              await Api().post("/transactions/bulk", {
                batch: transactionPost,
              });
            });
      }
    },

    fetchAllDevices() {
      Api()
        .get("/devices")
        .then((response) => {
          this.allDevices = response.data;
        });
    },

    fetchAllVlans() {
      Api()
        .get("/organisationBridgeTemplates/customer")
        .then((response) => {
          let vlans = response.data;
          console.log(vlans);
          this.allVlans = vlans;
          this.allVlans = vlans.filter(function(el) {
            return el.isActive === true && el.isDeleted === false;
          });
        });
    },
    viewTicket(item) {
      this.ticketItem = item;
      if (this.ticketItem.dueTime === null) {
        this.dateTimeSelect = false;
      } else {
        this.dateTimeSelect = true;
      }
      if (this.ticketItem.id) {
        this.fetchTicketComments(this.ticketItem.id);
      }
      this.fetchTicketAssignments(this.ticketItem.id);
      this.ticketItem.ticketCategoryId = this.ticketItem.ticketCategoryItem.ticketCategoryId;
      this.viewTicketModal = true;
    },
    fetchTicketComments(id) {
      Api()
        .get("/ticketComment/byTicket/" + id)
        .then((response) => {
          this.ticketCommentLog = response.data;
        });
    },
    fetchTicketAssignments(id) {
      Api()
        .get("/ticketAssignLog/byTicket/" + id)
        .then((response) => {
          this.ticketAssignedLog = response.data;
        });
    },
    createLocationContacts(contactId, contactTypeId) {
      Api().post("/locationContact", {
        contactId: contactId,
        locationId: this.applicationInfo.locationId,
        contactTypeId: contactTypeId,
        isActive: true,
        isDeleted: false,
      });
    },
    async approveApplication() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        if (this.provisionAccount()) {
          if (this.applicationInfo.packagesIspId !== null && this.applicationInfo.serviceAccountId === null) {
            let customerOrganisationId = this.applicationInfo.packagesIsp.customerOrganisationId;
            let vlans = this.allVlans.filter(function(el) {
              return el.customerOrganisationId === customerOrganisationId && el.isPrimaryVlan;
            });
            if (vlans.length == 0) {
              confirm(
                this.applicationInfo.packagesIsp.customerOrganisation.name +
                  " does not have a primary vlan assigned. Please create/assign a primary vlan for this ISP before continuing."
              );
            } else {
              confirm("Are you sure you would like to approve this application?") && this.approveApplicationProcess();
            }
          } else {
            confirm("Are you sure you would like to approve this application?") && this.approveApplicationProcess();
          }
        } else {
          this.provisionWarningModal = true;
        }
      }
    },
    async approveApplicationProcess() {
      if (this.applicationInfo.primaryContactId) {
        await this.createLocationContacts(this.applicationInfo.primaryContactId, 2);
      }
      if (this.applicationInfo.secondaryContactId !== null) {
        await this.createLocationContacts(this.applicationInfo.secondaryContactId, 5);
      }
      if (this.applicationInfo.billingContactId !== null) {
        await this.createLocationContacts(this.applicationInfo.billingContactId, 8);
      }
      if (this.applicationInfo.packagesIspId !== null && this.applicationInfo.serviceAccountId === null) {
        // let customerOrganisationId = this.applicationInfo.packagesIsp
        //   .customerOrganisationId;
        // let vlans = await this.allVlans.filter(function(el) {
        //   return (
        //     el.customerOrganisationId === customerOrganisationId &&
        //     el.isPrimaryVlan
        //   );
        // });
        // if (vlans.length > 0) {
        await this.createServiceAccount();
        // } else {
        //   confirm(
        //     this.applicationInfo.packagesIsp.customerOrganisation.name +
        //       " does not have a primary vlan assigned. Please create/assign a primary vlan for this ISP before continuing."
        //   );
        // }
      }
      Api()
        .put("/applications/" + this.$route.params.applicationId, {
          isApproved: true,
          approvedById: this.$store.state.user.id,
          isResolved: true,
          resolvedById: this.$store.state.user.id,
          resolvedDate: new Date(),
        })
        .then((this.applicationInfo.isApproved = true), (this.applicationInfo.isResolved = true));
    },
    rejectApplication() {
      if (this.authUpdate(this.$store.state.currentRoute)) {
        confirm("Are you sure you would like to reject this application?") &&
          Api()
            .put("/customer/applications/" + this.$route.params.applicationId, {
              ispVerified: true,
              ispAccepted: false,
              ispVerifiedById: this.$store.state.user.id,
              ispVerifiedDate: new Date(),
              //   resolvedDate: new Date(),
              //   isResolved: true
            })
            .then((response) => {
              this.notifyFno();
              (this.applicationInfo.ispVerified = true),
                (this.applicationInfo.ispAccepted = false),
                (this.applicationInfo.ispVerifiedDate = new Date()),
                (this.applicationInfo.ispVerifiedById = this.$store.state.user.id),
                (this.applicationInfo.ispVerifiedBy = this.$store.state.user),
                (this.deniedReasonModal = false);
            });
      }
    },
    getLinkedContacts() {
      Api()
        .get("/contacts/linked", {
          params: {
            idNumber: this.applicationInfo.primaryContactIdNumber,
            emailAddress: this.applicationInfo.primaryContactEmailAddress,
            mobileNumber: this.applicationInfo.primaryContactMobileNumber,
          },
        })
        .then((response) => {
          this.linkedPrimaryContacts = response.data;
        });
      if (this.applicationInfo.secondaryContactFirstname !== null) {
        Api()
          .get("/contacts/linked", {
            params: {
              idNumber: this.applicationInfo.secondaryContactIdNumber,
              emailAddress: this.applicationInfo.secondaryContactEmailAddress,
              mobileNumber: this.applicationInfo.secondaryContactMobileNumber,
            },
          })
          .then((response) => {
            this.linkedSecondaryContacts = response.data;
          });
      }
      if (this.applicationInfo.billingContactFirstname !== null) {
        Api()
          .get("/contacts/linked", {
            params: {
              idNumber: this.applicationInfo.billingContactIdNumber,
              emailAddress: this.applicationInfo.billingContactEmailAddress,
              mobileNumber: this.applicationInfo.billingContactMobileNumber,
            },
          })
          .then((response) => {
            this.linkedBillingContacts = response.data;
          });
      }
    },
    async getExistingServiceAccounts() {
      this.existingServiceAccounts = [];
      await Api()
        .get("/serviceAccounts/active/byLocation/" + this.applicationInfo.locationId)
        .then((response) => {
          this.existingServiceAccounts = response.data;
          if (!this.existingServiceAccounts.length > 0) {
            this.applicationInfo.isPackageVerified = true;
          }
        });
    },
    async getApplication() {
      await Api()
        .get("/customer/applications/" + this.$route.params.applicationId)
        .then((response) => {
          this.applicationInfo = response.data;
          this.locationContacts = [];
          if (this.applicationInfo.location && typeof this.applicationInfo.location.devices !== "undefined") {
            for (let i = 0; i < this.applicationInfo.location.devices.length; i++) {
              if (
                this.applicationInfo.location.devices[i].deviceMakeModel.deviceType.name == "GPON ONU" &&
                this.applicationInfo.location.devices[i].isActive
              ) {
                if (this.applicationInfo.location) {
                  this.device = this.applicationInfo.location.devices[i];
                  this.getAvailableTemplates(this.device.deviceMakeModel.deviceMakeId);
                }
              }
            }
          }
          // if (
          //   typeof this.applicationInfo.location.serviceAccounts !==
          //     "undefined" &&
          //   this.applicationInfo.location.serviceAccounts.length > 0
          // ) {
          //   for (
          //     let x = 0;
          //     x < this.applicationInfo.location.serviceAccounts.length;
          //     x++
          //   ) {
          //     if (
          //       this.applicationInfo.location.serviceAccounts[x].isActive &&
          //       this.applicationInfo.location.serviceAccounts[x].deviceId !==
          //         null &&
          //       ((this.applicationInfo.location.serviceAccounts[x]
          //         .fnoDeactivationDate !== null &&
          //         new Date(
          //           this.applicationInfo.location.serviceAccounts[
          //             x
          //           ].fnoDeactivationDate
          //         ) < new Date(this.applicationInfo.activationDate)) ||
          //         (this.applicationInfo.location.serviceAccounts[x]
          //           .ispDeactivationDate !== null &&
          //           new Date(
          //             this.applicationInfo.location.serviceAccounts[
          //               x
          //             ].ispDeactivationDate
          //           ) < new Date(this.applicationInfo.activationDate)) ||
          //         (this.applicationInfo.location.serviceAccounts[x]
          //           .fnoDeactivationDate === null &&
          //           this.applicationInfo.location.serviceAccounts[x]
          //             .ispDeactivationDate === null))
          //     ) {
          //       this.existingServiceAccounts.push(
          //         this.applicationInfo.location.serviceAccounts[x]
          //       );
          //     }
          //   }
          // }

          if (
            this.applicationInfo.location &&
            typeof this.applicationInfo.location.locationContacts !== "undefined" &&
            this.applicationInfo.location.locationContacts.length > 0
          ) {
            for (let y = 0; y < this.applicationInfo.location.locationContacts.length; y++) {
              if (
                this.applicationInfo.location.locationContacts[y].isActive &&
                !this.applicationInfo.location.locationContacts[y].isDeleted
              ) {
                this.locationContacts.push(this.applicationInfo.location.locationContacts[y]);
              }
            }
          }
          this.setActiveTabName("applicationContacts");

          this.getLinkedContacts();
          if (!this.applicationInfo.hasTvOverFibre && this.applicationInfo.packagesIspId === null) {
            (this.applicationInfo.isInstallVerified = true), (this.applicationInfo.isDeviceVerified = true);
          }
        });
    },
    formatDateTime(date) {
      if (date !== null) {
        return dateformat(date, "yyyy-mm-dd HH:MM");
      } else {
        null;
      }
    },
    notifyFno() {
      Api().post("/notifications/application/notifyFno", {
        applicationId: this.$route.params.applicationId,
        organisationId: this.applicationInfo.supplierOrganisationId,
      });
    },
    notifyIsp() {
      Api().post("/notifications/application/notifyIsp", {
        applicationId: this.$route.params.applicationId,
        customerOrganisationId: this.applicationInfo.packagesIsp.customerOrganisationId,
      });
    },
  },
};
</script>

<style>
.greenBorder {
  background-color: #e6e6e6;
  border: 1px solid #99cc33;
  text-align: center;
}
.v-stepper__header {
  box-shadow: none;
}
</style>
